module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("DEDICATION")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("HANK YOU TEAM AT SPARKLESOUP")]), _vm._v(" AND THE EDGE FOR WORKING SO HARD TO MAKE THIS BOOK SERIES COME ALIVE. A LOT OF LOVE HAS GONE INTO THIS BOOK AND ITS CHARACTERS.  THANK YOU FOR COMING ALONG WITH ME ON THIS JOURNEY AND MAKING IT A FUN AND HEARTFELT ONE.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("A Fatal Kiss")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("It is from an old Danish folklore that I learned of the Fatal Kiss, the kiss bestowed upon mortals by the beautiful Snow Queen, the Queen of Winter, a magical being of the fey. No mortal can survive her kiss. Yet, a mortal is constantly being challenged to survive this kiss, to overcome the fatal magic by the strength of love. Now the Snow Queen has a son, who is known as Jack Frost. Jack Frost was one of the first immortals whom I learned of who risked his immortality in order to follow his heart and love a mortal girl. Like his mother, his kiss is fatal to mere mortals. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-w"
  }, [_vm._v("W")]), _vm._v("HEN I WAS YOUNGER")]), _vm._v(", I dreamed dreams of Feyland. I was decked out in silk and satin – warm jewel tones hugging breathlessly against my body – dancing every night at the Fairy Ball. The waltzes were soft and low, my feet as light as whispers against the marble floor. I spent night after night in the arms of a fairy prince, who stared at me with eyes so piercing blue that I felt my whole body shatter and come apart ten thousand times in an evening. We would dance to the fairy waltz, tangled in each other's arms, gliding across the floor. The smell of bergamot would linger from the garden; the scent of jasmines would cloud our nostrils from so many bouquets spread across the ballroom walls. The light would sparkle as it faded into sunset, casting impish shadows through the stained glass windows. And I would be in the arms of a fairy prince who loved me, whom I loved with more power than the whole fairy kingdom could contain. But those were old dreams. I did not dream them now.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Now Feyland had become a place of terror to me, and when I dreamed I screamed aloud, and woke up gasping, with my throat raw and my eyes red and bloodshot. Now when I dreamed of Feyland, I dreamed instead of the forest where Kian first took me on my sixteenth birthday, when I had first been stolen away from my normal, mortal life, and told that I was a fairy princess, destined to become a fairy queen. The forests' trees were black with shadow and the cobwebs of night; the terrain was rocky and sharp stones nipped at my feet at every opportunity. I dreamed that I knew nothing of my power, of my birth – and yet in the dream I was wearing the crown that told me that I was the Summer Queen, in charge of the whole expansive land of summer and light, crops, fertility, and sun. In my dreams I knew there was always on my heel an assassin, an assassin whose face I did not see and whose name I did not know, but whose purpose was made clear to me in the fear that throttled my throat and the terrified beating of my heart. And the assassin, I knew, wanted my blood, wanted my death.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In the dreams I ran, ran with no magic or powers to protect me – for in the dream I knew none of my magic, but only how to run as fast as I could. I was alone, with no friends and no family, stranger to this even stranger place, where nothing and nobody made sense to me. The forests' tree-branches grabbed at me like so many sharp claws; the holes in the trees looked like eyes staring me down. The sound of the brook churning in the distance beat out the drumming certainty of my heartbeat, and as I ran the sound grew louder and softer in a senseless pattern, so that I couldn't even figure out where I was, or where I was going.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And all the while the assassin's footsteps grew nearer, and I could see his shadow flickering out before me whenever he came closer. I could smell the smell of death stiff and brittle in the air; I could not breathe, or else only wheeze out sharp terror.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("At last I made it through the forest. I saw the Summer Palace in the distance – every night a little different in my dream-memory, but always unmistakable: the orange-stained glass, the cloud-capped towers that shone with golden turrets, the endless gardens out front with their spraying fountains and the smell, ever-familiar, of bergamot. And the palace meant safety – though deep in my heart it struck a chord of fear – but yet I knew my mission was to get back there, to escape the assassin deep within its chambers, behind its guarded walls.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I ran, almost to the gate I ran, and began to breathe normally when the gate was just seconds away from my feet's reach, and then when I thought I was safe I felt the arrow ricochet straight through me and I fell to the ground. I fell to the ground, tasting dust and bitter earth. The assassin came closer and closer – and I could make out a tall figure, a man's figure. Was it Delano? He had tried to capture me many times before, and the memories of the days spent in his dungeon fill me still with other kinds of nightmares. But no – the hair was darker, for then I could make out the hair and it is anything but Delano's ashen blonde? Perhaps Flynn? The Winter Knight was known for his prowess and for his cruelty – he would have done anything to please the icy Winter Queen, and receive the bounty for having won the Winter Court the War. But no – as his face came closer it was clear...the hair is jet-black, and the eyes are piercing blue, and I knew then that there was no face and no hair and no eyes in the world that looked like that, except for the face and the hair and the eyes of the man I loved.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Kian.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The Winter Prince was before me, with his noble, knightly bearing and the impossible beauty that is paralytic at close range. And I wanted nothing more than to vanish into his arms, and his embrace, but I saw the look on his face and I remembered then that he was my enemy and that there was only one thing to do.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Run.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I leaped into the air, trying to escape, trying to run from him – but always I knew it was futile. Kian would know my every move, my every thought. When I feinted left, he followed me. When I darted to the right, he was there first. And at last he caught me around the waist, wrapping his arms tightly around me until all breath was expelled with a sharp sigh from my body, and then I knew that I was caught; I was trapped; I was his.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I turned to face him, and then I forgot why I could ever have wanted to run. In his eyes I saw only the memory of my love for him, and my fear turned to longing, as I wanted nothing for him to hold me as he used to hold me, kiss me as he used to kiss me. His skin was cold like ice, and I shivered to touch him. When we were together, he had always been so warm....he used to tell me that I had warmed him, that it was my Summer blood that kept him flushed at the cheek and his heart beating quickly. I could feel his fingers trace the contours of my cheeks, down the length of my chin and then up again, stopping at my lips.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In his eyes I could see the same love, the same longing. I wanted to kiss him; I wanted him to kiss me, and I could feel his longing so clearly I could not distinguish between my wanting and his. And in his arms I felt safe, warm, alive.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kian...” My voice was only a whisper. “I knew you would come for me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("His face betrayed no expression. His eyes seared through me. “I will search for you always, Breena.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I've returned!” I said. “I'm back – we're together...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“To rule,” Kian said. His voice was sharp and cold. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“To rule "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _vm._v("you,” I insisted, my voice rising higher. “To make peace. To rule for you – for us – for everyone in both kingdoms!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I will never forget you.” His eyes glittered, showing hints of silver as his voice was roused to passion. He closed his eyes, breaking the connection between us. “But we are at war. We are enemies.” His voice began to waver “We can never be together.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No!” I cried out, reaching up to him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Our lips met in a kiss, a kiss so powerful and strong that it felt our bodies had begun to shake, that they had been rocked to the bone by an earthquake within our breasts. It was like the first time we kissed – that same sense of love so strong that nothing else mattered, nothing at all. I wanted to lose myself in that kiss, for the kiss to stretch out into eternity, to feel nothing but the intensity of passion I felt in that very moment.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We broke apart, and immediately my soul cried out for him, longing for him, needing him closer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I am sorry, Breena,” he whispered.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Immediately I felt my body crumbling, shaking so fast that the very atoms of my being seemed to dissolve, and then I was dissolving too, my emotions shattering me, until there was nothing left of me but silver dust – and a final longing stare of awe, of passion, of love.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Our bond was broken. We were no longer intended for each other. Had we deluded ourselves with our love for each other that love was stronger than magic? That love was all that matters? ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With that kiss - that fatal kiss the beautiful but deadly Snow Queen bestows on mortals, now inherent in her son - the Winter Prince Kian, the bond was broken with my death.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")])])]), _vm._v(" sat up sharply, the harsh glare of dawn striking my eyes like lightning. I could feel my whole body shaking, my teeth chattering as if I had just been submerged in a pool of frozen water. The dream again.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It had come to me almost every night in the week since I had been crowned Queen. Sleep was supposed to be my refuge – the only time when I was free of the watchful eyes of Wort and the other advisers of the old Queen, whose purposes I was not yet sure of, but whom I decidedly did not trust. Sleep was the only time I was free – when they were not watching me, judging me, waiting for me to make a false move. And yet I dreaded falling asleep, for my dreams were the most dangerous time of all. In dreams I met Kian again, but he was not the Kian I knew, the Kian I had loved. He was my enemy. Tonight I had dreamed that he had killed me, and it was I who had shattered into dust; sometimes it was the other way around. Either way, the promise of my dreams was sure. Kian and I were enemies. I could feel my love for him when I woke, but at night I felt only fear, fear that our love would be impossible.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I heard a knock at the door. “Come in!” I called, but before I could finish my sentence Wort strode in, followed by a demure-looking handmaiden who kept her eyes fixed firmly on the floor. In her hands was a blue bowl, emitting the familiar smell of kelpie soup. As a baby, I knew, I had repelled one of these creatures; as an adult, I feasted on them – making use of the restorative and relaxing powers the kelpies were rumored to possess.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kelpie will put your mind at rest, my Queen,” said Wort. He came over to me and patted my hand; his skin felt like ice. “After all, you have had quite a shock...your coronation was so unexpected...” He dipped the spoon into the soup and brought it towards my lips.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No,” I whispered. I still didn't trust Wort, and I wasn't going to allow him to feed me behind closed doors, where there was no witness to any potential crime.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Come now, Your Highness,” said Wort. “You must be clear-headed and strong in order to rule as Queen.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I was clear-headed and strong enough a week ago,” I said, turning up my nose at the smell of the broth.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But all Summer Queens drink kelpie soup,” said Wort. “It will regenerate your powers, allow you to regenerate. All royal fairies in all the kingdoms drink it.” Wort did his best to smile a reassuring smile, which only made him look more like a toad than ever. “You haven't had any soup for two days.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Daisy, give her the soup!” Wort shouted. This was not the handmaiden I recognized – what had happened to the old one? Daisy seemed bright and cheerful enough, but her eyes had a distinct dullness to them. “Actually – come here. Open your mouth.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Daisy did as she was told and swallowed down a spoonful of soup. She grimaced.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That wasn't so bad, was it, Daisy?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“A bit bitter,” Daisy began chattering. “Though the aftertaste wasn't so bad. Ask me, I'll tell you to add a bit of honey and maybe some coriander – or a spring or two of rosemary...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That's enough, Daisy.” Wort rolled his eyes. “The point is, you're still breathing, aren't you?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I suppose so, sir,” Daisy looked confused.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well, if Daisy says it's good.” I reached for the spoon, but couldn't stop myself from adding. “But next time put in a spoonful of honey and a dash of coriander. And maybe two springs of rosemary.” I winked at Daisy.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Daisy grinned behind me as I swallowed down the soup. It was all I could do not to make a face, too. No amount of honey could disguise the bitter taste of kelpie.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'll leave the woman to dress you,” said Wort on his way out. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Let's get you dressed, then, Highness,” said Daisy. “I've got a gorgeous silk dress you should try – all the way from the Autumn Court! Red and orange silk!” She presented it, and I gasped at the way the silk fluttered so lightly in the gentle breeze. Like a brilliant flame, the dress lit up the room, bringing out the natural copper highlights in my hair. No doubt it was a beautiful dress fit for royalty, but I had something else in mind.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The Summer Knight Rodney. Does he have any armor he left behind?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Of course he does!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I want to wear that. You can will it to resize, if you think it would be too big.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Daisy's eyes grew big. “But you're a Queen!” she protested. “You have to wear something befitting a Queen – Wort said...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'm afraid I don't care what Wort said,” I replied. “I am my father's daughter – and as long as necessary I will take over "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("his ")]), _vm._v("duties in the Summer Court. Including going out and meeting my subjects.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Daisy’s eyes widen. “The last queen did not even bother visiting her own homeland once she became Queen...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I smiled. “Perhaps the last queen did not care to as she was content waging war from the safety of the palace. I am the new queen here, and I am not nor will I ever be like the old queen.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Daisy immediately cast her eyes down and knelt on the ground bowing down. “I’m sorry to have offended you, my Queen.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No offense taken,” I said. I saw the girl breathe out a sigh of relief. “Daisy, I would like to know, however, how you came to be here. You are from the Autumn lands, right?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Daisy looked up and nodded. “We followed Redleaf, Princess of the Autumn Kingdom, here for her marriage to the Summer King. It was part of the treaty.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I nodded. I knew about the Autumn lands being merged into Summer’s sovereignty. My father Foxflame had told me about it when he explained how he had to marry his brother’s fiancé Redleaf to assure peace between the Summer and Autumn Courts. Foxflame and my mother were already in love and together when Foxflame became the Crowned Prince upon his brother’s death. With his marriage to Redleaf, the Summer and Autumn Courts merged.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tell me,” I asked Daisy. “Do you like it here?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, well, there is plenty to do around the palace, and I’m kept busy...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I mean, do you like being here in the Summer Court, the Summer lands?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” Daisy said. “Here we have food; there is plenty of harvest and sun. In Autumn, many of our people faced starvation.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So for the most part, most of the Autumn denizens were grateful to be part of Summer?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I believe so. For me, yes,” Daisy said frankly.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That is good to hear.” I patted Daisy’s hand in a gesture of sympathy. “I’m sure the death of Queen Redleaf shocked many.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“She was one of us, an Autumn denizen, the last of the royal Autumn fairies,” Daisy said. “There were those who had hoped to resurrect the Autumn kingdom, but many who are grateful we are part of Summer rather than Winter.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I had to smile. At least the myth of how vicious and cruel the Winter Queen was would keep the Autumn denizens in Summer loyal. I wanted to see what my denizens thought of the new Summer Queen. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Get me Rodney’s armor, Daisy. I must leave when there is enough sun.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Nobody will believe you're a royal in a knight's garb, Your Highness,” said Daisy.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That's the idea,” I said. “If I'm going to rule this kingdom, I want to know about it. I don't want people to tell me what I want to hear – not like the last Queen, who would have cut off their heads for disagreeing with them. I want to know the truth.” If I was to be Queen, I reasoned, I was going to be a good one. I was sixteen years old and had learned the truth about my identity a matter of months ago. I had a lot of catching up to do. And I was finding out that nothing was at all like it seemed.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In a few minutes I had donned the silver armor of a fairy knight and mounted my horse, the slight tightness at my breastplate the only hint of my gender. I kicked my stirrups in and began riding – the path out of the castle taking me through the palace gardens. I remembered the first time I entered Feyland, how beautiful it had seemed to me then. It had been terrifying, yet its strangeness had given it a fairy beauty. I had dreamed about it so many times that the place had felt familiar from the moment I entered, but so strange was that familiarity that it felt I hadn't known the place at all. I had been terrified of the denizens of Feyland – the monsters and Pixies and fairies who lived there. Now this place was my home, and the few creatures that frightened me were now my neighbors – to be lived alongside, to be reckoned with. They still frightened me, and I didn't understand them – and yet I knew that I must. I was responsible for their lives, for their care. I was responsible for keeping them safe from the Pixie invasions, and from the collateral damage from the war with the Winter Court. I was responsible for their health, their happiness.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My father had cared for these creatures so much that he had left behind the beauty and splendor of the Summer Palace, and spent months at a time in disguise as a lowly knight, roaming his kingdom and learning about what his subjects really needed. Now it was my turn to do the same. But I knew I would miss the Summer Palace. Although my incarceration there had been terrifying, and Wort and his minions still made me feel unsafe and unwelcome at every turn, I knew deep down that I belonged there. I had been dreaming of the glamour and shimmer of the ballroom since I was a little girl, long before I even knew what fairies were. I would miss it, for it already felt like home. I would miss the satin sheets and the smell of oranges floating in from the garden, would miss the exquisite marble statues in the front hall and the glimmering of gemstones from the throne room. Since I had been crowned Summer Queen, it seemed that the palace had begun to gleam more brightly than before, as if the sun itself and all the essence of summer had descended upon the court. I knew that the Court under the reign of the old queen had been a hard and dangerous place, but when my father and I had returned home together it had seemed, however briefly, that a new hope had dawned for the court. I had the power to bring it to its former glory – the glory that I had dreamed about as a child that I remembered from my infancy. I could bring peace and prosperity to the kingdom, and end the old queen's reign of tyranny and fear. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My heart ached as I left the Summer Palace behind. Would I return to it victorious, ready to be a queen once more? Or would I return to find danger and treachery lurking around every corner, behind every column? If I was to be safe, I knew, I had to win over the hearts and minds of the people – for if I were loved by them Wort would never dare to have me assassinated or incarcerated. I needed the fairies as much as they needed me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We rode onwards, my horse and I.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("As we rode, I saw forests so green that they looked like the far end of the ocean, and rivers that bubbled and shone like diamonds. I saw plains of long, tall grass and whistling meadows made alive by crickets. It was as if I were seeing Feyland for the first time – all its beauty coming alive within my eyes, new and glorious. This was the fairyland I had dreamed of – but it was more than that.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I was the Queen of this entire kingdom.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("This was my country.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("This was my kingdom.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_vm._v("I")]), _vm._v(" had been riding all night and into the morning. The dawn was spreading its rosy fingers across the horizon, tracing patterns of gold dust in the crimson expanses. The sun left pink and sienna rays all over the sky, and in the distance I could see the first tentative up-creeping of blue. I was exhausted. Fairy magic and desperation alike had caused me to feel little pain at first – my legs had remained tensed in the saddle – but after twelve hours at last I was beginning to feel the dull ache in my muscles that meant I had gone too far.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My horse seemed to agree with me. He was giving a low, mournful whinny every time I kicked in the stirrups – and it was in the end that my horse's exhaustion, more than mine, compelled me to stop. We were on the shores of a lake, and the sunrise was reflected large and orange in the water. The second I dismounted, I felt my muscles relax all at once, a single fluid motion that caused me to tumble down onto the soft, sweet grass. My horse, too, seemed to enjoy it. Horses here were not like horses in the mortal world – no sooner had I left his back than he began rushing and rolling in the grass, rather like a large dog, legs in the air and limbs askance. I couldn't help laughing at the sight.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Come on, then,” I whispered. “Get some water – we don't have much time.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With an indignant neigh, the horse leaped back onto his feet and began treading towards the water. He sniffed tentatively, then began drinking, slurping down great gulps of the liquid with distinctively equine glee.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Then, suddenly, I saw a bubbling on the horizon.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My heart stopped – could it be?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Back, Coral!” I cried, but the horse was too immersed in the water to hear me. “Back!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I put a hand on my sword as the kelpie rushed out of the water, its webbed wings slashing through the air like so many swords.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A kelpie in a soup was distasteful enough, but alive kelpies were not only rebels but also dangerous. They could live on land or in the sea – emerging from the watery depths to mate with mortal horses to continue their cursed line, and to eat airy children. As a child, I'd been told, I had repelled one of these creatures and proven my worth as a fairy, but at sixteen I had no idea how to manage this fairy magic. I had only my sword.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Time seemed to stop. As I saw the kelpie rear up, splashing the lake into a series of torrential waves, I saw in the back of my mind a glimpse of my fairy childhood. I remembered nothing of this life – only the same ball I dreamed of again and again in my sleep – and yet somehow in my mind was a clear picture of this very lake. I was only an infant, swaddled in the arms of my mother, Raine – the Summer King Foxflame's chief consort and true love. We were having a picnic – a tenuous crowd made up of my father, my mother, and my father's wife, the imperious Summer Queen Redleaf, who had borne the insult with brave silence even as she glared daggers at the two of us. I remembered the glistening white and blue sand, the caresses of the nursemaid who fed me and tried to teach me the difference between Feyland's two burning suns as my mother tried, in vain, to make small talk with the Summer Queen – and then that familiar, terrifying bubbling at the edges of the water...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The Kelpie had grabbed the nursemaid first, clamping down with razor-sharp teeth and dragging her into the murky darkness of the water. I had tumbled from her arms and landed – bruised but ultimately unharmed – on the pillow-soft sands.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And then the kelpie had come for me. Its teeth had widened over me; I had smelled its rotting breath.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And then it had gone – and nobody knew why. Even Redleaf had agreed – I was the strongest fairy baby they had ever seen.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Some consolation, now. This kelpie was definitely not being repelled. Could it be I have lost some of my fairy magic since being raised in the Land Beyond the Crystal River?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Coral, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("back")]), _vm._v("!” By now the horse had sensed the danger, and galloped back from the edge of the lake. But it was too late. The kelpie – with velvety black fur and two horns poised for destruction – was charging straight towards us. Its eyes glowed red and ferocious – its teeth were sharp: at least twenty rows of powerful daggers. Alongside the velvet fur was a series of sharp scales – like the scales of a snake or a lizard – with the unshapely legs of a salamander. The horse's hind legs gave way to a serpentine tail.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I swallowed hard. Nothing I had seen in the mortal land or Feyland was quite like this. Was this what Feyland was, in the end? A land of danger, of fear? The mortal world, the world of Gregory, Oregon, had never seemed so far away.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The kelpie clamped down on Coral's tail, and my horse reared and whinnied in distress, eyes flashing like lightning in the rising of dawn.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No!” I shouted! “No!” My fear forgotten, I rushed at the kelpie with the sword. My blow was just hard enough to make the kelpie drop Coral's tail – and Coral instantly galloped off into the woods, spurred on by his terror.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("That just left me and the kelpie. I brandished my sword again, striking anew. But this time the kelpie was prepared for me, and caught the sword between its teeth, flinging it away with as little effort as if it had been a toothpick. My blood froze. The kelpie had left the water, now, and was leering at me as it ran on its lizard-like legs, its mouth open and poised to swallow me up whole....")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("All I had left was magic.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I hadn't used my magic since ascending to the throne, but now it was my last hope. I concentrated, hard, summoning the forces of Summer. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Your Queen commands you")]), _vm._v(", I whispered, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("help me.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Suddenly, a burst of reddish-orange light was thrust out of me – a burning, rolling fireball that glimmered like the sun, rolling towards the kelpie. I could feel the air sizzle with spark and life, my body warming up as the heat emanated through my very core, radiating out through my body and rushing from my fingertips. The beam hit the kelpie straight in the chest, and the smell of burning flesh filled the air as the kelpie was set aflame.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I took a few steps backwards, watching the kelpie burn, my heart still pounding in my chest, when suddenly a clear, human voice – like a male child's – came from the kelpie.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Help me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I stopped. Suddenly the creature before me wasn't a monster, wasn't a danger – but was something like a child – able to plead for its life. Had I just committed murder? I was the Summer Queen – and it was my duty to protect everyone within my kingdom, even the kelpies. But I was wary of going closer – the last thing I wanted to do was end my days in the stomach of the beast.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Before I could make a decision, a large, hairy creature leaped in front of me, growling and snarling. It was a wolf. He bared his teeth at the kelpie, giving it an insistent snarl.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("At once the kelpie retreated into the water, its singed flesh sizzling as the water extinguished the flames. “Beware,” it was saying. “Beware, Summer Queen, Queen of Fire. Beware of the curse of the courts.” And then it vanished into the waves.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I stared at the wolf – its eyes familiar, even in animal form.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Logan?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")])])]), _vm._v("t had been only a couple of weeks since I had last seen Logan, but it felt like much longer. The last time I had seen him, he was with my mother – at her side, loyal as a wolf even in his human form, accompanying Raine back across the Crystal River, to the land where we had grown up – the land of mortals. A few weeks or months ago I might have called it “my” world. But now it seemed that my true home was instead here. I had told Logan that at the time – told him that it was time for me to remain in Feyland, and follow my destiny. I had told him that we could only ever be just friends, that our time together was limited by our separate destinies. He was a werewolf, and I was a fairy, and I belonged firmly, squarely, in Feyland, while the weres straddled the borders between the two worlds – wanted by neither, belonging in neither. I had feelings for him then, even when I told him that there was nothing between us. It was better, I thought, to cut him off completely than to lead him on, to make him contend with my feelings for Kian, as impossible as they were. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But now, as Logan began transitioning before me, the smooth silver fur of the wolf vanishing into a tanned, deep olive color – the color of his skin, his muscles, his broad shoulders bare before me, I almost regretted that decision. The eyes of the wolf, loving and longing and loyal, were now set squarely in the face of a man, but they were still staring at me with that same devotion, that same puppyish desire. I could feel my heart breaking quietly as I stared at him – a break that I knew was but the smallest echo of what I had made "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("him ")]), _vm._v("feel when I broke his heart by the banks of the Crystal River.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I know what you said,” Logan was saying. His voice was wavering, shaking. “That you wanted me to go back to my normal life – my other life. That you wanted me to leave you alone...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I didn't mean it like that!” I started.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I know what you said...” Logan repeated. He came closer to me, and as he walked I could inhale the deep and familiar scent of his musk. It reminded me of tree bark and fir trees and pine needles, of the heady scent of the woods behind the high school at Gregory, Oregon. How I missed that scent. It felt safe, felt like home, where my mother was, where Logan and I spent time together exploring the woods, talking about dreams, and worrying about simple things like homework and preserving those woods. Once, those woods had been my favorite place in the world. Logan and I had spent hours walking there, tracing trails, finding secret places and hideaways. The smell brought back so many memories – of the way he had stood by me all through my childhood and adolescence, standing up to the school bullies like Clariss for me, holding my hand when I needed a friend, refusing to let the popular girls mock me for my strangeness, my artistic sensibilities. And then in Feyland, too – he had saved my life time and time again. He had suffered imprisonment and risked death to deliver me from Delano, the Pixie King. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I sighed inwardly. I didn't deserve his kindness. I didn't deserve his devotion. I felt the pressure – so familiar now – to respond to his love, and against myself I inhaled his scent again. I tried to remember Kian – remember what I'd promised – but Logan’s devotion brought me weak to my knees. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We travel back and forth across the Crystal River, we werewolves,” Logan was saying softly. “So you see, I came back. Your mother is safe.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I was shaking, trembling as he came so close to me, lightly brushing my shoulders with his fingertips.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I heard what happened. With Rodney and the Summer Queen. The "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("former ")]), _vm._v("Summer Queen.” Before I could speak he wrapped his strong arms around me, enveloping me in the warmest, safest hug I had ever experienced. I melted into his chest, feeling his sturdy fingers stroke my back, massaging the aching, tensed muscles in my neck and shoulders. That was Logan, I thought. Always strong and silent, always aware.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It felt good to surrender, for a change. Since the murder of the old Summer Queen, since my coronation, I had been called upon to be so strong. I had to be a firm ruler, a brave ruler, one that never faltered. Any mistake I made could cost thousands of Summer and Winter fairies their lives. The assassination of the Summer Queen had only made matters worse – tensions between the two kingdoms were at an all-time high. And it was my job to negotiate the tensions. My father lay in perpetual sleep, under the unbreakable spell of the former Queen, and Kian was imprisoned, thrown and shackled under the darkest, tallest tower of the prisoners of the Summer Court. In the past few weeks, I felt more alone than ever before.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I remembered those high school bullies. How silly, how immature they all seemed to me now. I had once worried about Homecoming Queen; now I was a Queen proper in a land where my dreams and nightmares converged! There was more than crowns and glory as queen. There was the duty to your people. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Even so, it was nice to feel protected.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Breena,” Logan laughed. “You really did a number on that kelpie just now. You're finally getting the hang of that whole fairy thing...” His voice trailed off.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ever since my coronation – being Summer Queen.” I stopped. The words still sounded strange to me. “I've been stronger. At least that's how it feels. It was when I wore the Crown of the Summer Queen, that I felt more like a fairy.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Not just any fairy,” Logan broke in. “The daughter of one of the strongest, best-loved kings in Feyland. The magic of the other fairies recognizes your royal blood – it responds to it.” He paused. “Royal coronations are serious stuff here in Feyland, Bree. It’s not just a figurative transfer of power, it is a literal one. Whatever magic the last Summer Queen had, it goes to you. With that, how could you be anything but so much stronger now? Exponentially stronger, even!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I don't know,” I sighed. “It's all happening so fast.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He touched my nose lightly. “I guess you don't need my protection anymore. Not like the old days.” He let the side of his hand brush against my cheek; I felt it tingle.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How about a friend instead?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I could always use a friend,” I laughed. “Especially now. I can't say I have too many of those in the fairy courts.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He looked me up and down, considering my outfit – the shining armor of a fairy knight.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'm going to take a wild guess,” said Logan, “and say you're on a journey somewhere?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I nodded.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But what kind of Queen takes a journey without her royal entourage, her bodyguards?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Maybe a Queen who doesn't want to be found,” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Feyland is dangerous,” said Logan, sighing. “Beautiful – but still dangerous. What's so important that you're willing to take that risk, Your Highness?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I didn't answer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“If you don't know what you're up against, Breena, Feyland could be more dangerous still. I've seen creatures so deadly, so dangerous that I'm still waking up with nightmares. And compared to the creatures I haven't seen – but have only heard of – the ones I've seen are nursery rhymes. Your strength and magic won't do you much good without knowledge. That kelpie just now – it was trying to get to you. If you'd so much as touched it with your bare hands, you would have been stuck to it – the scales emit some kind of glue. You would have been pulled into the water to drown.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I stopped and took a deep breath. How close had I come to feeling pity for the creature?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wow, I didn't know that,” I said. “Thanks, Logan.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He gave me a wry smile. “Anytime, Breena,” he said. “I don't want to see you dead anytime soon.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I can't believe I didn't know that!” I felt so stupid.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You're not expected to, Breena,” said Logan. “You're human after all – or at least, you grew up as one. I know Kian tried to teach you as much as he could about Feyland.” He made a subconscious grimace when speaking Kian's name. “But it's not like you can really get a handle on this stuff without, you know, having grown up here.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Like you,” I said. How strange – it had always felt as if Logan had grown up with me. How many secrets had he kept when we were growing up?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The best of both worlds,” said Logan. “Human and fairy – all rolled into one. Or the worst of both worlds.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And werewolf,” I added. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And werewolf,” Logan said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I sighed. “I know my mother was only trying to protect me,” I said. “But I can't help it. I'm angry. I wish I knew all these things earlier – so I can protect myself now.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan sighed and nodded, wrapping his great arms even tighter around me. “But just imagine what kind of danger you would have been in then, Breena.” He let his fingers trail down my back and then began grasping at my hand. “You wouldn't have led a normal life, for starters. Never known about your mother's side of things...being human. Considering how alluring glamoring is, not to mention magic, you would have forgotten about your human half altogether!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That’s true,” I had to admit. Since knowing I had fairy blood in me, I have grown more and more entrenched in learning about everything fairy.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m almost glad you didn’t learn about your fairy heritage until later,” Logan said. “Considering how fairies don’t think much of werewolves.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I smiled up at him. “I hope to change that. I, for one, think very much of one in particular. I missed you, Logan.” I was blushing.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I missed you too, Breena,” he said softly. “Very much.” I could see him looking into my eyes, searching my face for any signs of love, of passion. He wanted to see if I missed him as much as he missed me, if I loved him as much as he loved me. Was he still willing to go to the ends of the earth, or to Feyland for me? Willing to fight for me – or defend me with his life? I knew that he had always loved me, spent our whole friendship wanting me, wanting this – since we were five or six years old. As I looked at him, I wanted to tell him how much I cared for him, too. He had been my friend, my confidante for so long, and I could not imagine my life without him, but my mind thought of Kian, locked up in the dungeon of my own kingdom, and I couldn’t bring myself to say those words Logan longed to hear.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He realized I wasn't about to confess my love anytime soon, and so he cleared his throat, perking up. “So, Miss Adventurer, where were you sneaking off to before you got side-tracked by that kelpie?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I sighed. I knew how Logan would respond – the topic would darken his face with shadows of his regret. I didn't want to hurt him, but less still did I want to lie to him, and if Logan was to accompany me on my mission, he would do well to know what he was fighting for, what we were fighting for.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I cleared my throat and spoke.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“To find Kian.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")])])]), _vm._v(" was heading for Rodsgard, the Autumn fortress where Kian had been taken. It was a ways from the Summer Palace, in the Autumn vassal territories. Only the most ruthless of Summer prisoners were taken there, to spend their final days in the barren wilderness of dry autumn before their execution. There was nothing I could have done. I had just been crowned Summer Queen, but a quick look at Wort's face was all I needed to know – I was a Queen in name only. If I so much as said a word in Kian's defense, Wort would have me branded as a traitor, and even if he didn't kill me himself, he would ensure that a “popular uprising” of “concerned citizens” did his despicable job for him. I could feel the power of Summer radiate through my body, but in this I was powerless. I could not voice my love for him. Being a Queen was just another form of a cage.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("As I sat Logan down on the sweet-smelling grass, explaining to him the reasons for my journey, my mind flashed back to that horrible – terrifying day. I had expected to see the execution of Rodney – my steadfast friend and lover of Shasta, the Winter Princess. The Summer Queen had wanted him killed as an example: there could never be peace, nor friendship, between members of the Summer and Winter Kingdoms. But the execution had been stalled by the assassination of the Summer Queen and Rodney's disappearance.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Everybody knew who was behind it – the Winter Court, of course! The individuals didn't seem to matter. And yet only I had seen the warrior holding the blade – proud, strong Shasta, whose love for Rodney would not let her stand idly by. I watched as she cut Rodney loose and rode away with him on her shining blue stallion. Was she my enemy now, this Winter Princess, who shared the same beauty as her brother? Was Shasta, whom I had always admired,– always longed to be like – my enemy?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("At the time my heart had fluttered in fear for Shasta – long after she had vanished into the mists. And then, before I even realized what was going on – I had been crowned the Summer Queen. Everything had happened so quickly – a crown was being forced upon my head, and words I could not even understand were chanted over me. In moments I could feel something strange and mysterious within me – something overwhelming, a new kind of power. This was the royal heat of the sun, strong and fierce like fire, the magic of summer – and I possessed it. But one look at Wort's leering face was enough to turn that power into nothingness. I knew his intentions were no good. He was loyal to the old Summer Queen, who hated me almost as much as she had hated my mother, and I wasn't about to win him over easily. When Wort had woken me up that night, dragged me to the throne room before dawn had broken, and announced that they had captured the assailant, the Winter Court assailant responsible for killing the Summer Queen, it was for Shasta that my heart began to beat. But when they presented the prisoner to me, I was shocked to see instead the face of Shasta's brother, the man I loved, Kian. He had been beaten up – his skin was marked with bruises blue and purple, but I could still see the love shining for me in his eyes. I could feel our telepathic connection spark us both, as he expressed to me his love, his happiness that I had ascended to my destiny and become the Queen of the Summer Court. My heart broke as I realized there was nothing I could do. My people had demanded revenge against the Winter Court, spurred on by Wort's propaganda, and they called out for the spilling of Kian's blood")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Wort and his men, the old Queen's advisers, knew how these things worked. They waited up with me all night, hasty to spill blood first thing at dawn. I could smell the sadism and violence in their breath. How was I to execute him – that was the question, not "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("if")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("At last I spoke, measuring my words carefully, knowing that one false step would bring both Kian and me to ruin. “I will not make a hasty decision,” I said. “There is no proof, after all, that this fairy is the one behind the assassination.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No proof!” Wort sputtered. “He is a Winter Prince! That is all the proof we need.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It will only make matters worse,” I said, my voice shaking. “If we act rashly now, we may worsen the situation – the Winter Court is already in an advantageous military position. If we execute the heir to the throne, we risk no-holds-barred destruction, civilian deaths, pillaging. Meanwhile, the Winter Court is holding as prisoner many Summer Court knights – sons, brothers, husbands of many of the women of this court. Are we to forfeit their lives, too? For you know if we execute this Winter dog that is what the other court will do. They will not hesitate to execute their Summer prisoners.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Wort gaped at me in amazement. “We can't just let him go!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Precisely not. We will keep him imprisoned – and bargain for his life with the Winter Court. They return our hostages, and we let him live...in a tower of our choosing. They do not...and then you may execute him as you see fit. We cannot waste our leverage at this opportunity.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But the people want him dead!” Wort insisted.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I wish to think about that,” I said. “I will consider for a few days. In the meanwhile we shall treat the Prince with the kindness and respect that we afford our prisoners of war here in the Summer Court, in the manner in which we hope the Winter Court would afford our own prisoners.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With that I disbanded the meeting.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("As I walked out, I sent Kian a telepathic message, gathering all my love and strength into a single thought.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("I shall see you soon, my love. Be strong, and do not hate me for being so cold. They must not see that I love you or it would mean sure death to both of us...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I retreated to my room, shaken to the core. I crumpled down onto the bed, weeping into my pillow, hugging it closely to my chest, feeling as cold and empty as the great and hollow room that was now my bedchamber. They had Kian – Wort and his men. It was worse than the Pixies. At least when the Pixies had Kian, for all that they were dishonorable bandits, you knew they would find some use for him. Delano would never be stupid enough to kill a prisoner when he could get something out of it – and the Pixies' true priorities were money and power. But Wort and his group – a group whose limits and members I did not even yet know – only wanted Winter Blood at any cost. Despite my reassuring message to Kian, I knew we were both still in danger.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I tried to use telepathy once more now that my mind had quieted down. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Kian?")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I heard his voice, as soft and reassuring as the Summer rain. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Breena, I do not hate you. I understand. ")]), _vm._v("There was a pause. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Shasta should not have killed the Queen....")]), _vm._v("But his voice trailed off, and I was left alone in silence in my room.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A few minutes later I heard his voice again, stronger than before. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Breena, they are here. They are taking me elsewhere!")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My heart leaped with alarm! Had Wort disregarded my orders, chosen to take the matter into his own hands and execute Kian anyway.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Where")]), _vm._v("? My voice grew frantic.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("I don't know. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("At once my eyes misted over, clouded by a vision. I was seeing through Kian's eyes – seeing what he saw. Menacing Summer Knights brandishing shackles came closer and closer, swinging their chains with malicious glee.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We're taking you somewhere you won't see the light of day.” I could hear the cruelty alive in their voices. “They say it is the End of Summer, this land.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Kian – no!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But it was too late. Kian had already begun trying to fight. He punched one square in the face, but the others were too quick for him, outnumbering him five to one. They landed on him, pummeling his ribs and arms and legs. As if I were there myself, I felt the bruises on my own body, screaming out with pain. Who were these knights? And where were they taking Kian?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Before I could follow him any further, a brief knock came at the door. Before I could answer, it flung open imperiously. Wort was standing there, flanked by a demure-looking maiden.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“My Queen,” he said, bowing deeply. His obsequiousness was apparent from the way his robe touched the floor – I knew not a word of it was sincere. “I thought you'd like some nourishment.” He gestured to the maiden, who approached me with a foul-smelling bowl of what looked like dirty gasoline.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“This will help you relax.” He waved, and the maiden brought forth a golden spoon. “Kelpie soup – the soup of the royals.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I made a face, however involuntarily.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No thanks,” I said. Even if I had trusted Wort, the soup looked like a mix of tar and burned rubber, and smelled even worse.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That's what the last queen said, at first,” said Wort. “But look what a magnificently strong and powerful queen she was.” His voice became soft, even lustrous then, talking about this old Queen he had so admired. “When she first became Queen, she was but a mere young woman, newly married to a king she barely knew. After drinking kelpie soup, she gained clarity of mind, of purpose, and realized her power as Queen.” Wort smiled, showing green teeth. “It's what sets apart a mere fairy from a royal fairy, a fairy meant to rule. All royal fairy women drink kelpie soup.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I sighed. I realized there was no help for it – there was no way I was getting out of this one. I might as well get this out of the way, fuming in anger at what Kian was going through. If I drank this soup like a good little girl, perhaps Wort would answer my questions about Kian.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I reached for the spoon, but Wort jerked it away. He handed it instead to the young maiden, who used the spoon to scoop up a spoonful of the soup, put it in her mouth, and swallowed. Hard. Wort looked her up and down, his eyes scanning her frame. “See, nothing to be afraid of...my Queen.” He spoke the words as if they were an insult. “Here you go.” He scooped up another spoonful of the soup and handed it to me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It tasted worse than it smelled. I couldn't help it – before I could stop myself, I instinctively spit it out, right in Wort's face.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That's not going to help you,” said Wort drily.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I sighed. There was no help for it. “Alright,” I said. Just pretend it's medicine, I told myself. I put it in my mouth and swallowing, forcing down the noxious liquid. I could feel it burning my throat as it went. As soon as I swallowed it, I knew it was a mistake.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Now, sleep,” said Wort, waving his hand over me. Instantly I became drowsy, and my eyelids felt as if they were made of lead. As my vision grew fuzzy, Wort looked even stranger than usual to me – his normal toadish form becoming more pronounced, until he almost seemed like a giant frog. All the questions I had about Kian and where he was being taken, faded along with my consciousness.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Trying hard to keep my eyes open, I muttered, “What are you? You don't look like the other fairies here...and your magic. It's different.” This didn't feel like fairy magic.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'm your loyal Summer denizen,” Wort said. “Before then, I was of the Autumn court...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("So many courts! “Aren't we all fairies, despite the different courts,” I asked, as I drifted off to sleep.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, not all of us are fairies,” said Wort. But before I could press him further on the subject I drifted off to a dark, deep, sleep.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("That was the first night I dreamed that Kian was my enemy, that I would have to either kill him or let him kill me. The dream had haunted me every night since.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-l"
  }, [_vm._v("L")])])]), _vm._v("ogan furrowed his brow. I could hear his sigh – deep and throaty, like the cry of a wolf raising his hackles. “Kian,” he said – and I could hear the anger in his voice, palpably throbbing with jealousy. “Of course – I should have guessed.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Look, Logan...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You're about to risk your life, your kingdom, your crown – your power – not to mention your safety...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kian is my...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My voice trailed off. I didn't really know what to call Kian. Was he my boyfriend? My fiance? We had been engaged once, as children, when we were too small to know the ways and trials of love. But things were different now – the split between the Winter and Summer Courts had made that complicated, and now with Kian a prisoner in the Summer Tower, I wasn't sure what we were at all. I sighed. I knew how I felt, what my heart told me was the truth. Did Kian feel the same way? Or did he resent me – the decisions I would have to make as Summer Queen, his sworn enemy.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'll give you some time,” I said. “To think it over.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That would be good, yeah.” Logan drew in breath sharply as he cast his eyes heavenwards. “I could use a second...just – to get my head around all this. Your Highness.” His voice was cold, but I could hear the emotion raging within.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I went into the forest in search of my steed, which had whinnied and vanished at the arrival of the kelpie. I knew that Logan's answer wouldn't change my course. Regardless, I had to go find Kian. He was my true love – I could feel it deep within my bones. It was my destiny. It was the only choice I had.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("As I forced my way through the emerald brambles, whistling my horse's name softly to the wind, I reflected on my options. I knew there was no way out – I couldn't get Kian released through diplomatic means. If I tried to give an order, Wort would see it as a direct attack on his authority – and he'd start to think that the cons of having me alive outweighed the benefits. I had a sense that the last Queen, Redleaf, had been under his command. I wondered if Redleaf as I had known her – the strong, powerful, broken woman who had put her husband, my father, into an unwakeable sleep, had really been such a bad person after all? Or had Wort influenced her, turning her anger and jealousy at her husband's affair into the rage that fueled Wort’s political machinations.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I wanted Logan with me. I needed him with me. But I couldn't force him. He had already put his life in jeopardy before for Kian, and nearly been killed by the Pixies for his trouble. I had suffered sleepless nights mourning his death before I'd learned that he was alive, suffering as their prisoner. I could not ask the same favor of him twice.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I looked around – there was no sign of my horse. I'd never be able to find the steed at this rate, I thought, as I trudged back towards the banks of the lake. Logan was waiting for me, staring out at the iridescent sky. His gaze was as piercing and strong as the horizon. He let out a low moan from the depths of his throat.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What are you...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Suddenly, I heard a whipping through the trees, followed by the familiar clopping sound of horseshoes. My horse nudged through a bramble of trees, and trotted over to Logan, bowing at Logan's feet.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Of course. Logan was good with animals – his wolfish nature gave him a connection with all the fauna of Feyland. Even the fastest horse in the Summer Stables would willingly give up freedom if it meant answering Logan's command.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Logan,” I said softly. He turned to look at me, startled that I had seen him summon the horse. “I know how you feel about Kian...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I knew what I wanted to say. I wanted to release him from his bonds, to set him free to go home to the mortal world, to tell him that I could take this trip on my own, that I didn't need his help, but he silenced me with a single, tender touch of his fingers on my lips. His fingertips felt as light as the breeze.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'm going with you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Before I could protest Logan continued on, his voice steady like the river. “I know you, Breena, and when you set your mind on something, there's no holding you back.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Logan..”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Remember that Wilderness Protection Society we started at school?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I laughed as the memory came flooding back to me. I had been so obsessed with saving the woods behind Gregory High School that I became convinced that everyone else in the school would be, too. I'd spent hours putting the letters up on banners with my stencils and copying out reams of information on sign-up sheets.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“There were only two members,” I said, smiling. Logan had proudly put his name down on the list – the first, and only, signup I got that day. “Me and you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Only just the two of us,” said Logan. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("How could I not love him? He was the strongest, truest, bravest friend any girl could ask for. But he was more than that, even now. As I stared into his eyes, feeling his dark gaze wash over me, I knew that any human girl – or fey, for that matter – would be drawn to him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Two,” said Logan, “but it was a start. That's how things get started, Breena. Brave things. It takes something...It takes someone brave to do what everyone else is afraid to do first. It takes somebody really special.” He took another step closer to me and I could smell that familiar woodland musk on the back of his neck. “You've always been that person, Breena. The one brave enough to be the first.” He enveloped my hand in his, warming it with his touch. “I came back not only for my own selfish reasons – because I missed you – but because I believe in you, Breena.” He smiled softly and cast his gaze down to the lake banks beneath us. “You are a true queen now, but you were always a queen to me. Back in school, when we had no friends but each other. When it came to protecting the nature preserve behind the school. Always. I won't abandon you now on this quest, not when you need me the most.” He took a deep breath. “As your friend,” he added.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("As my friend. I felt a slow warmth developing in my heart. Logan was a true friend, I knew that much. Whatever feelings we'd had for each other in the past, whatever had transpired between us over the past few months when, overcome with relief, I'd been so glad to learn that he was alive that I'd let my attraction to him get the better of me, I would always have him as a friend – there would always be that bond between us. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, Logan,” I said. I gave him a tight hug. He closed his eyes. “Oh, Logan! I can't tell you how happy I am to see you.” I laughed. “What am I going to do with you?” I leaned in close and whispered in his ear, even now afraid of the old Queen's spies in the woods. “Nothing at the Summer Court is as it seems. The Queen – she wasn't behind the war, after all. It's her advisers – "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("my ")]), _vm._v("advisers now. And they're a scary bunch!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I could see Logan's eyes widen in surprise. “But the Queen, everyone thought...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, it wasn't her! I don't think she was the nicest woman in the world, but I don't think she was as mad as it seemed. I think...I think Wort was controlling her. Her mind. Wort's her chief adviser – a fairy from the Autumn Court. Only I don't think he's a fairy. There's something about him. Strange. Scary. It's not fairy magic. It doesn't feel like fairy magic. He was from the Old Queen's Autumn Court, and you know, I don't think he's too happy about Autumn being part of Summer.” I turned away from him, trying to gather my thoughts together. “I don't know what it is, Logan, but I think Wort's trying to poison me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan put a protective arm on my shoulder. “What? Why?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“He kept insisting that I drink this soup he made me. Kelpie soup. He said it would help clear my thoughts, that it was something that all royal fairies drank.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan made a face. “Kelpie soup? Like that creature we just fought?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I couldn't help laughing at his disgusted expression. “Yes! And let me tell you it tasted every bit as nasty as it looked.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I don't know anything about Kelpies,” said Logan. “Other than what I told you. I don't know if that's normal – but it doesn't sound right...somehow.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The soup made me sick. And it gave me bad dreams.” I didn't tell Logan what kinds of dreams they were. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well, you're safe now,” said Logan. “No more kelpies, in soup form or otherwise. We've got to keep you safe here – and keep Kian safe too. That's our mission.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Thank you!” My gratitude came pouring out of me. “I know how you feel about Kian – I know you didn't want to, didn't have to...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I am your Knight,” said Logan. “And Kian is important to you. He has saved my life before.” He sighed. “But I'll be honest – that's not why. I don't care for him one bit, you know that. I wish you'd never met him. But if I let him die – it will kill you, Breena. It will. If he dies under the orders of your own Court – I can't let you suffer like that. I can't let you suffer that guilt. I can see it in your face.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Logan...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Not to mention – you think the war's bad now? What happens when the Winter Queen hears that your court killed her son? When Shasta hears that you let her brother die – when she trusted you to save him somehow! You think Summer will be safe? Look – their forces are stronger. Their might is greater.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I stopped short. I hadn't even thought of that. I'd been so worried about the threat from my own court that I hadn't been able to process the threat from my enemies. I'd always liked and trusted the Winter Queen and Shasta. But until I had the power to stop the fighting – and convince my people that the war needed to be over – they were technically my enemies. Was this Wort's plan all along? To set me up to further the war, further the fighting? He didn't need to hurt me. He had the Winter Court to do that.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan looked at me, his gaze growing serious. “It's a good thing you sneaked out of your own court when you could. Somehow I get the sense that this Wort person wouldn't have taken “I'm not hungry” for an answer. And speaking of answers, until we get one, I'd advise you go on a diet that avoids kelpie soup.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You don't have to convince me!” I said. “That stuff is disgusting.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'll do some research.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wort was very insistent I drink it,” I said. “And that makes me all the more worried.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan nodded. “First things first, Breena. Let's get Kian out of there. If, as you say, this prison is all the way at the end of the Summer Kingdom, near the Autumn border, we'll need to get there fast. I don't know much about Autumn – I've never been there – but I do know you should probably stay away from the Summer Court as long as possible – at least until you get Kian out of prison. The way things are now – I think it's more dangerous for you at the Summer Court right now than maybe everywhere else in this kingdom.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I sighed, shooting Logan a wry smile. “And to think,” I said softly. “I'm supposed to be in charge.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 6")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")])])]), _vm._v(" hadn't been able to communicate with Kian since that last, horrible night, when he had been taken from me and forced into the prisons of Autumn. I had called him many times, sometimes even murmuring out to him telepathically in my sleep, but always I had received no answer. I imagined that the magic in the Autumn prison was strong enough to prevent Kian from sending me messages. As Logan and I prepared to depart for the border, I thought back to the hazy memories I had of our earlier connections, the images that Kian had sent me through our connection of the prison – what he could see, what was around him. I racked my brain, but the images, as uncertain as they were, were entirely unhelpful. I couldn't remember ever having seen a clearing like that – a tree like that – a river like that. I sighed. Even if I managed to elude the guards of my own Court and the soldiers of Winter, I still had no idea where Kian was, only that the prison was in Autumn.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How big is Autumn, anyway?” I asked Logan.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He shrugged. “Pretty big. Bigger than Summer.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I didn't know how much time Kian had left. Would we finally find the tower – only for it to be late? I sighed and tried to push the image out of my mind.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Suddenly, I heard a familiar voice reverberating in my brain.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Breena?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It was Kian! My heart leaped as I heard his voice – faint but still so strong – whispering at the very depths of my soul.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Breena, where are you?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("I'm coming for you, Kian. I promise. I'm coming to find you. You need to tell me where you are.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("I've been trying to get through to you every day...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Where are you? ")]), _vm._v("I wanted to know as badly as he did how we had managed to communicate, longed to speak to him and whisper words of love, but now I had time only to implore him to tell me where he was. The connection could be cut off at any moment, and I couldn't risk losing his location.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("I'm not sure, Breena.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Is there a window? Look out – tell me what you see. ")]), _vm._v("“Logan!” my human voice sounded strange to me now. “Listen – I've got his location. There – Kian's telling me...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan stiffened, but he stood close to me, nodded.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("There are three mountains – three next to each other.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Three mountains...” I said aloud.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("And between the left mountain and the middle one there's this river – or stream – something...I don't know...I hear the sound of rushing water.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“There's a river nearby – running through two of the mountains.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("I think I'm facing east – I've seen the dawn before.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Facing east.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Can you see any other towers around you?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("A village – at the top of the mountain. I don't know what it's called. I don't know where it is.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“There's a village – a village at the top of the mountain! Logan!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I got it!” Logan grimaced.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("There looking for you, Breena. I heard the guards, heard them talking. Wort and his advisers have started the search for you – your whole Court is looking.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I'll have to hurry. ")]), _vm._v("I tried to concentrate harder, sending all my thoughts, my desire, my love straight into Kian's mind. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("We have to hurry before they find me. ")]), _vm._v("My love was strong, filled with the overflowing passion I had tried so hard to put out of my mind. I could see Kian receiving my love reeling back from the force of my desires, as if he had just been struck. He put a hand against the cold stone wall to steady himself, and I could feel the damp against my own palms. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I love you, Kian. ")]), _vm._v("I imagined kissing him – imagined out lips touching.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I could feel that he felt it.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("I love you, Breena. War or no war, you will and always will be my Queen.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I felt the emotions overtake me, turning my limbs into water. I felt as if Kian had wrapped his whole being around me, so tightly, hugging me tightly with the ends of his soul. I could feel my heart beating quicker, my breath growing shorter as I sighed.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Breena!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My eyes shot open. Logan was preparing my horse, fixing the saddle into place.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You okay, Breena? You kind of spaced out there for a moment.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My face, hot with embarrassment, gave it away. “Uh, sorry,” I muttered, looking down. Logan could see right through me – and the knowledge of this filled my cheeks with fire.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Listen,” said Logan, not looking at me. “If you want to rescue your lover, then we have to get going now. I think I know the village he's talking about – there's a village called Birds Pass up by the Sandstone Mountains, with a river. I think it might be the one. It' about a day's ride away – but I've heard this horse here is the fastest breed in Feyland. Maybe we can do it in half the time.” His face softened as he extended a hand to me to help me up.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I took his hand, and before I was aware of what was happening I found myself in Logan's arms, lifted up into the air. His grip tightened around me, warm and soft and strong, as he helped me into place, settling me down on the horse. As he sat before me, his legs straddling the horse's back, he did not move his arms away. He remained there, with his arms tight around my waist. Even now I couldn't resist breathing in his scent, lowering my gaze at the pure, heated intensity of his eyes. For a moment, I thought – with something between fear and anticipation – that he was going to try to kiss me – his lips were only centimeters away from mine. Before I could protest, Logan turned away, his gaze lingering a moment longer on my lips.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I breathed a sigh of relief. Thank goodness Logan hadn't tried, I thought to myself – the last thing I needed was another awkward situation. I needed to focus on Kian right now. And yet I couldn't deny that my heart was beating faster still, and it took me a few moments of riding before I caught my breath.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Put your hands around my waist,” Logan said hoarsely. “Hold on.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I did so, feeling his muscles taut beneath my grip.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I was glad he hadn't tried to kiss me. It made things easier. And yet somewhere, in a deep, dark part of myself between knowledge and desire, I felt disappointed that he hadn't. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Get yourself together, Breena.")]), _vm._v(" I shook myself out of it. I had to keep Logan as a friend, and that meant not leading him on.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan jerked at the reins and gave a swift kick, and soon we were riding into the verdant brightness of the forest. The scenery was beautiful, here – breathtakingly colorful vines and fruit trees, scented with apples and oranges and all the fruits of the forest that have no name in the mortal world, but are known in the fairy language only. I gasped as we continued onwards. I had seen the beauty of Feyland many times, but somehow it never had seemed as beautiful to me as it did right that second.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan heard my sharp intake of breath. “It's gorgeous, isn't it?” He laughed. “I always used to miss it so much – going back and forth between the two worlds. Mortal and fairy. It was this world I always so longed to see...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("His voice trailed off.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But you were always worth coming back for,” he added.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I couldn't help but blush. The canter of the horse forced me against Logan's back repeatedly, causing me to grip more tightly around his waist. The movement of the horse had caused us both to become tired, short of breath – but the redness in both our faces wasn't just exhaustion. I tried to ignore the fluttering feeling inside me as we sat so physically close together. We were both fully aware of each other. But as Logan's dark hair blew out behind him, and I could smell the woodland musk upon him, I felt that every creature in all of Feyland could see my attraction plain on my face. Involuntarily, I tightened my hold on his waist, feeling the taut muscles of his abs beneath my hands. I’ve always thought Logan was so handsome. Whenever we would touch, it felt warm and safe. But ever since my sixteenth birthday when we almost kissed, every single touch, every single look meant much more. As I looked into his face, my arms encircled around his waist, smelling his wonderfully masculine scent, I wonder how I can deny that what we had was more than friendship?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 7")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")])])]), _vm._v("t was dark, now. The suns of Feyland, which had hung so pendulously in the sky, had vanished, leaving in their place twinned silver moons. One was white and whispering – as cold and still as the Winter Kingdom. The other, closer and bigger, was a vague yellow, giving off a faintly golden glow. We had traveled for miles through the kingdom, following Kian's directions as best we could. We ascended up the tall mountains and found the stream of which Kian had spoken of, near a village where we were able to pick up some much-needed food and water. Logan and I had fallen into a pattern of silence. Our exhaustion mingled with our awkwardness, and we didn't even speak to each other over our bowls of hastily sipped fairy fruit juice. For my part, it was a relief to eat something other than kelpie soup – it felt that my dormant taste buds had at last begun to spring to life.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan and I continued on in silence, until at last – when the twinned moons hung directly above us – we came across a jagged, tall tower – like a desiccated branch – dotting the horizon.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That's it!” I whispered. “That's Kian's tower – I can feel it!” And indeed my heart began seizing as I experienced a pang of longing at once instantaneous and overwhelming. “Keep close!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We kept as close to the branches and bushes as we could, not wanting to be seen. The shadows of the foliage cast a cloak of darkness over us. Coral stopped short, rearing up upon her hooves.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What is it!” Logan whispered.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Then we saw it – the unmistakable emerald shimmer of a snake glistening in the grass. Coral reared up in terror – just enough to distract us from the two assailants coming in from behind. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We responded instantly, our adrenaline pumping through us. Fists came at us from all sides – the great blows of a large figure and the light, agile kicks and sword-thrusts of a smaller one. Logan and I went back-to-back, coordinating our blows as if we were able to look into each other's minds. They had not expected us to respond so quickly or so well, and before long I was able to seize the smaller attacker, grabbing his torso so tightly that the sword clattered out of his hand and into the ground. Logan, for his part, was squaring away with the larger figure, baring his teeth with wolf-like intensity. I grabbed the smaller figure and put my hands squarely on his neck.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Stop!” I shouted. “Or he dies.” My voice only faltered a little – I hoped the larger assailant wouldn't call me on my bluff. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The larger figure stopped and hesitated as my fingers trembled and tightened on my hostage's pulse, where I could hear the heartbeat rapidly fluttering against my fingers.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What you will!” The larger man's voice was warm, soft, and unmistakably familiar. “Only let her go!” He thrust down his sword.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I knew that voice. And I knew that the figure with him was the one he would do anything for.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Shasta?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I whirled around my own captive to face me. Glamour could disguise a face, but it couldn't trick away those tiny, bird-like bones. No wonder she was so small.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Take off your glamour right now, Shasta” I cried. “I know it's you!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Shasta's glamour fell down like a curtain, revealing the Winter Princess herself in all her cold, haughty beauty. Once she had been a friend of mine – and I had admired her easy, regal confidence, but now her eyes were filled with rage against me. What had I done?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Rodney?” Logan's voice broke the silence as Rodney too revealed himself – his mop of curly red hair appearing from the shadowy disguise. Rodney too looked angry, stern – his handsome features distorted by the absence of a smile. Once a knight of my court, Rodney had defected due to his love for Shasta. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("What was going on?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What are you doing?” I asked, as soon as I got my voice back.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Saving my brother,” said Shasta simply. Her tone was harsh and strong. Her piercing eyes stared out at me from beneath her head of unruly dark hair. “The new Summer Queen, apparently, cares more for her crown than she does for her friends.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What?” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“She apparently refuses to negotiate Prince Kian’s release under any conditions!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Negotiate?” My mouth fell open. “What negotiations?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, please,” said Shasta. “Cease your excuses. My mother sent messengers and messengers, so many of them to negotiate – but you turned them away without even bothering to see them. And we heard that my brother was held prisoner, awaiting his execution!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It's not true!” I protested. “I was never told of these messengers – I promise you, Shasta! I'm trying to save Kian, too. It's why I'm here now.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Really?” Shasta raised an eyebrow.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Really – you know how much I...” I caught myself just in time. “I care for your brother deeply – so deeply that I'm risking everything by being here right now to save him.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Then why didn't you...?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wort's knights. His men. I've been a prisoner in my own palace – with no power to make any decisions, no abilities – I've been poisoned by kelpie soup, kept weak and sleepy and exhausted so I couldn't reign. That's why I escaped.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Shasta's face darkened. “And now you've come to help save him!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It's true!” Logan said. “I know her – I know Breena. And she'd do whatever it takes to help Kian. Why else would she be out here alone, in secret, in a knight's costume?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Why indeed?” said Shasta.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“To save Kian!” I shouted.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“If you wanted to save him, you could have issued an order.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I can't do a thing publicly! The people of Summer are baying for Kian's blood. Aside from Wort, publicly freeing Kian would mean risking my own life. No thanks to you! Your assassination of the Summer Queen is what caused all of this in the first place! You're the reason your brother is in prison – for your crimes, I might add! So don't get all haughty on me, Shasta!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“She was going to execute Rodney,” Shasta cried. “If I hadn't stopped her...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“There are consequences for your actions, Shasta,” said Logan gravely. “Breena may have become queen, but it is but a title. She has no real power in a kingdom so divided by factions and strife. The old Summer Queen's advisers are behind the war against the Winter Court, they were from the first. And now we are further away from peace than ever before! Even with Breena herself on the throne.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The Winter Queen is furious with Summer for capturing Kian, and ignoring all attempts at negotiating for his release.” She bit her lips and looked down, before propping up her chin and taking a good hard look at me. “Kian does not know how much Mother actually cares. She is prepared to gather an army to storm the Sumer Court if Kian is hurt.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rodney broke in at last. “I convinced Shasta to help me rescue Kian before it comes to that. I cannot have my friends and family at the Summer Kingdom killed. That's why we're here.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I see,” I said. “Then perhaps we could work together after all.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I gave a nervous laugh – but it was not echoed by the others around me. It was clear that the tensions among the four of us would be a serious barrier to saving Kian. Once, we had all been friends together, and had danced together at the Winter Ball. But such days seemed far behind us now. Is this what the world had in store for us now? Would we too become enemies like our parents?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Was this how War happened?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 8")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-w"
  }, [_vm._v("W")])])]), _vm._v("e stood looking at each other for quite some time. At first our stares were cold and harsh, wary of each other. We had almost dueled each other to the death, after all, and even now that we had expressed our common cause it was clear that we had not begun to trust each other. I could see Shasta's silver-blue eyes looking me up and down. Was I going to betray her, she wondered. Was I going to betray her brother? Was this all just part of the plan for me to rule both kingdoms? Not that I could trust her any more that she could do me. After all, how was I to know she wasn't going to stab me in the back once Kian had been saved, and take over Summer?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan and Rodney were shifting awkwardly on their feet, waiting for us to defuse the situation. Slowly, as time passed and the first flickers of dawn appeared on the horizon, we began to calm down. Our breath became deeper; our heartbeats became softer. Shasta and I continued staring at each other, but deep down we knew the truth. We both loved Kian – more than we loved our respective political situations. And we would do whatever it took to save Kian, and to make him happy. Rodney and Logan knew this too, and although jealousy was displayed clear as sunlight on Logan's face, he was nevertheless the first to speak, talking in a gruff, hoarse voice.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Do you know anything about this prison?” Logan asked, staring intently at the ground. “Where, uh, where your brother's being held?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rodney cut in. “I was a Summer Knight, once,” said Rodney. “Before I chose love over war. I guarded this prison once. I know the way in.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How?” My voice grew higher with anticipation. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“There is a secret tunnel – not far from this clearing. It's the only way in – it's how soldiers get food in and out. It's at the root of a thick tree, dug in under the moat. It's guarded by seven Summer Guards.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Will they listen to me?” I asked. “If I order them, as Queen...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rodney gave a grim smile. “Your power as Summer Queen,” he said, “makes you persuasive – whether fairies want to listen to you or not. Certainly...Redleaf had that power.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I could hear the anger in his voice when he spoke her name. After all, the Old Queen Redleaf had nearly had him executed for the crime of loving the Princess Shasta. But what Rodney said twinge a flicker of hope in me. Away from Wort and the poisonous kelpie soup, would I be able to use the Summer powers for good? The powers that I’ve inherited?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So, if I just ask....”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It's not about "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("just asking")]), _vm._v(",” said Shasta, rolling her eyes. “It's about "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("commanding. ")]), _vm._v("Harnessing regal fairy power. I have some – not as much as my mother, of course...” I could discern jealousy in her voice. Once, Shasta was the crown Princess – and I envied her for it. But now I was Queen, and my power far outstripped hers. She had to know this.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Then what happens?” I asked, ignoring Shasta's barbed remark. “I can't just "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("command ")]), _vm._v("the soldiers to let Kian out.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The ones in the clearing,” said Rodney. “You can get them to stand aside – if you harness your powers correctly. I don't think it will last long – they're bound to realize what's happening sooner or later, but by then we'll be safe inside the castle.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And we'll have Kian to fight with us!” Shasta looked pointedly at Logan. “He's the best fighter I've ever seen.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("If Logan were a wolf at that moment, his hackles would have risen. The top of his ears grew crimson, but he stood his ground, resting his strong feet in the earth. How strong he was – silent and stoic? If only it were easier to ignore the attraction I felt towards him, to devote my attention totally to Kian. I loved Kian – I did! The memory of his kiss still left me weak at the knees, still left my lips quivering and tasting of summer sun. But when I was near Logan, his attraction towards me, his feelings for me, became overwhelming. I could not ignore them – the full, animal force of his longing. I admired him; I respected him. And now I had to force myself to separate myself from him. I hated seeing Logan hurt like this, but I knew why Shasta was so brittle. She had once accused me of choosing Logan over her brother Kian – and while she would allow me her favor as long as she was confident that I truly loved her brother, she would kill me before she allowed me to hurt her brother, even for a moment. And whatever had happened, or not happened, between me and Logan – it would definitely hurt Kian if he knew how confused I felt. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Very well,” I said, taking a deep breath. “Let's go!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I've got an extra sword in my pack,” said Shasta. “For Kian.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We made our way through the woods according to Rodney's directions. At last we came to what was unmistakably the right clearing. Seven Summer guards dressed smartly in the finest armor were guarding what looked like an ordinary tree.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That's the one,” whispered Rodney. “I remember – the hole in the tree leads to the passageway.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I hope you're sure about this,” said Shasta.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You can do it, Bree.” Logan squeezed my hand.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The four of us walked straight into the clearing – straight into danger. The seven guards instantly put their hands upon the swords.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You will let us past,” I said, in my most regal voice. “By the order of the Summer Queen.” My voice let out a little squeak at the end, strangled by fear.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We'll "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("what?")]), _vm._v("” said the first guard, peering closer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He hadn't been hypnotized. I tried again, trying to harness the Summer power.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You will let us past, by the Order of the Summer Queen!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Look here, young man...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I closed my eyes and concentrated. On my need to get Kian out, on my love for him, on the taste of his kiss – on the glowing, throbbing, royal power of the Summer Sun...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("You will let us past,")]), _vm._v("” I said, my voice unearthly and not my own. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("“By order of the Summer Queen.”")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The soldiers grew still and sleepy.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Of course, Your Highness,” said the main guard, in a voice that seemed to be coming from a million miles away. “We exist to do your bidding.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Very well,” I said in a clipped voice. The guards stood aside, and we could see the narrow hole in the enormous tree trunk, leading down into the tunnel.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Let's go then.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("One by one we forced our bodies into the tiny entrance, until at last all four of us were underground. The tunnel smelled dank and miserable, filled with icy cold air, but our conviction and bravery warmed our hearts as we walked faster and faster.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That must be the moat overhead!” said Shasta, as we heard the sound of running water. “We can't be far, now!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("At last a twinkling light at the end of the tunnel told us that we had finished our journey. We clambered up a spiral staircase that creaked with every step and held on tightly. At last we opened a trapdoor and found ourselves squarely in the midst of a narrow corridor that slanted upwards in a spiral, heading higher and higher. Kian, I remembered, was at the very top of the tower.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We held our swords more tightly as we continued onwards.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Come on now,” said Shasta. “Hurry! They'll get their minds back soon enough, and then they'll be waiting for us.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We were lucky. No guards were guarding the tower itself – as it had no entrances and no exits, they were all in the clearing for the time being.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("At last we reached the top of the tower, our feet aching with the journey. We came to a little wooden door bolted shut with iron.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The keys!” hissed Logan, pointing to a set hung on the wall. We frantically grabbed hold of the keys and forced them into the lock, rushing into the door all at once.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kian!” Shasta cried, rushing ahead into the arms of her brother.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sister?” came a weak voice, buried by Shasta's lithe body. At last the figure stood up before us, and I gasped. Even ill-treatment, malnutrition, and torture had not diminished his great fey beauty. He was paler than before, and thinner, but the same deep-blue eyes and soft lips were there, fixed upon me in a look of longing, of love. At once I was filled with such love and desire for this fey prince that filled my dreams both day and night. But my body shook with anger at Wort and the Summer knights who had mistreated Kian. No one can mistreat my intended like this and get away with it!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We've brought you a sword!” Shasta cried, thrusting the sword into Kian's hand, but he was evidently distracted. His eyes had turned to me, and were shining with love and devotion.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You came, my darling,” he whispered. “I knew you would come.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("There was no time to allow myself to fall into his arms. My heart was still beating swiftly; danger was around us on all sides. The soldiers would surely have come out of their trance by now, and would doubtless in a few moments be knocking on the door we had hastily bolted shut.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh no...” Shasta whispered.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We heard the sounds of the soldiers' footsteps trampling down the corridor, the noise as deafening as elephants' steps. We flung our hands onto our sword-hilts.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“There's no way out!” Logan shouted.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The window...” said Kian softly. It was barred, and beneath us was a hundred-foot drop. “I didn't have enough magic to break it down on my own, but with all of us together.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And then what?” Shasta broke in. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian shot her a stern look. In a single, swooping motion, he tore his tattered shirt off his back and threw it to the floor, his muscles taut and rippling in the evening light. Behind him spread a vast and expansive set of silver wings. “They have not clipped me,” he said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Shasta flashed him a look and extended her own – they fit neatly through two slits in her armor. Clearly she was used to this.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You take Logan,” he said to Rodney. “I'll take Bree.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Who's in there?” The guards' voices were deafening, echoing through the chamber. “What's going on?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The door's locked!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Of course the door's locked; it's a prison!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No – from the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("inside!”")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The guards began battering down the door, pummeling it with their fists. It was now or never.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Concentrate,” said Shasta, as we all – the four of us fairies – fixed our magic together on the bars of the window.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Harder!” Kian shouted.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It felt like an earthquake was taking place in my brain. My concentration was hard and fast, fixed on those few narrow metal bars that were the only thing standing between us and safety, us and true love...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The iron began to shake, trembling softly in its position, vibrating – slowly at first and then faster and faster. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Now!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A golden light from me and Rodney was taking hold of the bars, accompanied by a strange, silver light we had never seen before. The twin lights seized the bars, then in a blinding flash threw the bars into the air, wrenched loose of the prison. They fell swiftly to the floor.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Summer and Winter magic, working together. The gold and silver flames of magic forged a stronger magic than the iron bars. Iron was not fatal to the fey, as some believed in lore, but it was still a strong metal, which was plentiful in Feyland. Apparently not strong enough against the combined magic of Summer and Winter.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You first!” Shasta pushed me in Kian's direction. “Meet you at the clearing!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The guards were still battering down the door, but there was no time for me to protest. I let Kian fix his arms around me and jump from the window. For a few moments, we fell, and I felt a sickening feeling in my stomach as we plummeted, the earth coming ever closer. But then I heard the feathery, harsh sound of Kian's wingspan, and we were traveling up again, higher and higher until the tower itself was nothing but a dot or a memory. Despite Kian’s exhaustion, his royal fairy blood gave him the strength to hold me tightly while flying into the dark night sky. I turned around to see Rodney and Shasta, carrying Logan in tow, beating their wings against the night wind. As Kian’s wings flapped strongly, his arms drew me in tighter until our bodies were holding each other as though we would never let go. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian’s lips brushed against my forehead before settling briefly on my lips. “Oh Breena,” he said against my cheeks. “I had every faith in you that you would set me free, but for a while, I almost thought...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hush,” I said. “I’m here, and I’m not letting you out of my sight anytime soon so keep holding me tight.” I looked down, a little more than afraid of plummeting hundreds of feet down.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian chuckled softly at this before he said, “You will get them, too, one day.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What?” I asked relishing being held in his arms. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Your wings,” he said simply. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I nodded as though I always knew this. But deep down inside, I gave a small tremble. Despite how brave I appear to everyone, I had always had a fear of heights. Knowing that I was going to have fairy wings one day, made me shuddered.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Cold?” Kian asked, wrapping his arms around me so I can feel the slight warmth of his body. His hands began rubbing my arms, creating more warmth.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I nestled in closer to Kian as I felt the night air create a current under Kian’s wings. “So I’ll get wings, too,” I said. “When?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian said simply, staring ahead. “When you become immortal.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("At last the clearing came into view, and the wing beats slowed as we made our way to earth again, bumping our feet on the ground.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I feel a little seasick,” I murmured as I felt the ground cool beneath my feet.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I looked up. There we were, the five of us. Safe. Together. Free.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 9")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-w"
  }, [_vm._v("W")])])]), _vm._v("hen we were rushing to escape from the fortress, Kian hadn't had time to take in more than the basics of who was rescuing him. But now, as we stood catching our breath, obscured from view behind a series of pomegranate trees, Kian began to look around, taking full stock of his rescuers. “Sister!” he cried joyfully, rushing into Shasta's arms. She gave him a protective bear hug.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Don't you ever worry us like that again,” she said, her voice loud with feigned anger. We both knew what she was thinking – that her actions, taken to see Rodney, had gotten Kian into this mess. But it was plain on her face that she was too proud to say as much. She continued to chide and berate Kian for worrying her, for getting captured, and yet from the slight waver in her voice and the redness spreading across her face Kian – and I – knew what she was really saying. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I'm sorry, brother. I love you.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And Rodney!” Kian enveloped Rodney in an embrace. “I am so glad my sister was able to rescue you, friend.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I hoped to rescue a damsel in distress,” said Rodney with a weak smile. “Instead I have fallen in love with a brave knight as well as a beautiful princess.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I suppose a good brother would tell you that if you hurt her, I'll kill you,” Kian laughed. “But somehow I think Shasta would get there first.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Kian!")]), _vm._v("” For the first time since we had met each other in the woods, Shasta seemed like a teenaged girl again, embarrassed about her brother's teasing. Her white-marble cheeks flushed even redder than before.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And...Breena...” Kian's voice grew soft and his cheeks, too, began to flush. I could feel the love pouring out in his voice, the love so visible on his eyes and on his lips. The presence of the others felt too strong, even oppressive. How I wished that we were alone, so that we could fall into each other's arms and whisper words of love!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian walked over to me, taking my hand in both of his and pressing it deeply to his lips. “I thought of you, my love,” he whispered. “Every day.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I thought of you!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Suddenly, the others did not matter. Our audience did not matter. There was nobody in the world but us.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The five of us.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I pulled away, suddenly, breaking the spell. Logan was still there, leaning against a tree, trying with all of his might not to look at either of us. Kian and I exchanged glances – not now, not yet. But soon.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sensing our discomfort, Logan broke the silence with a loud cough. “Well,” he said, his voice stiff and awkward. “We should probably get going. The last thing we want is to be locked in that tower again!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Agreed!” Shasta sprang up. “Come on, let's go!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Err,” Rodney spoke up, his cheeks turning almost the color of his hair. “One thing, though.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What?” Shasta shot back.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Where are we going?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("This silenced us. We realized, with a sickening feeling, that we had nowhere to go – there was nowhere that would welcome the five of us, Summer, Winter, and werewolf, together. My court was dangerous for all of us – and anywhere else was full of other sorts of dangers, from Pixies to wild beasts.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("We've ")]), _vm._v("got to go back to the Summer Court,” said Logan, taking a protective step forward and standing right in front of me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Breena, you can't let Wort rule in your absence. You need to head back, to seek power in your own court!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And risk her life?” Rodney broke in. “I know Wort – when he was Redleaf’s advisor, we all feared him. He's a tricky player.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We must go to the Winter Court,” said Kian. “My mother...she's been worried about me, been waiting. I must let her know how I am. I fear if she does not know the situation she may attack the Summer Court for having dared to imprison me. She believes that the Summer Queen – that Breena – has imprisoned her beloved son and refused to listen to any of her pleas for clemency, that the Summer Queen has sent away all messengers unheard. She is bound to seek revenge, to attempt to attack the Summer Court for her own ends.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You think our mother would act so swiftly?” Shasta shot me a glance. “She knows an outright military attack at this stage would result in at least one Court's destruction.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“If not both,” Rodney added ruefully. “You never know – once war starts, it's like a dam being opened up. You can't stop it up again.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Winter has the military advantage,” said Kian – shooting me an almost apologetic look - “I think my mother's the kind of woman who would take that risk.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Especially if her son's life is at stake.” Shasta put a hand on Kian's shoulder. “She cares, you know?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A pale pink flush appeared under Kian's milk-white skin.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I know you don't think she does – but she...when she found out you were imprisoned, she was...so hurt, angry, upset. She would have burned down all the forests of Feyland if it meant getting you back.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, come now,” said Kian, his voice thick with irony. “That wouldn't be productive.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Even Mother,” said Shasta, “isn't always rational.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well, that's settled then,” Logan brought in. “It's not safe for Bree to go to the Winter Court. She'd be captured and executed the second she arrived.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Even we can't ensure your safety,” Shasta added. “If you come to the Winter Court, who knows what Mother will do? Even if we try to explain – she'll think it was your responsibility to keep Kian safe. Which it was.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Didn't I help save him?” I responded, my cheeks flushing hot with anger. “Doesn't that count for anything?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I know that,” said Shasta matter-of-factly. “But do you think the Winter Court knows that? Or the people? How will it look to them if the Summer Queen shows up, with the crowd baying for her blood, and then walks away scot-free – back to her kingdom to destroy the Winter Court forever?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I wouldn't do that!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But that's how it'll look,” said Shasta. “Don't you see that?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I don't care.” I took a deep breath. “It's the only chance I have. It's the only chance I have to talk to the Winter Queen face to face.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Breena...” Kian's voice held an ominous warning.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, I mean it! Call it a diplomatic visit, if you want. But it's the only way I can talk to your mother without worrying that my words might be intercepted by Wort and his advisors. I know that the second I go back to the Summer Court, I'm practically incommunicado. My advisors have been withholding information for me – refusing to tell me about messengers arriving, keeping me in the dark. When the Winter Queen wanted to negotiate Kian's release, they didn't even tell me! Kian could have been executed in there and I wouldn't have even known!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well, whose fault is that?” Shasta shot back. Even now, her protectiveness of her brother outweighed our friendship. I could tell that she still didn't trust me, even after we'd saved Kian together. As long as I was the Summer Queen, I was a threat.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'm trying to fix it now,” I argued back. “The only way I can. If I'd received that letter Kian would have been freed by now. I would have found a way to get Kian released while still keeping the people happy – exchanged him for land, or for another political prisoner, or something!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But it's not safe!” Logan insisted.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I don't care,” I said. “Staying in the Summer Court isn't safe either. Every step I take, every move I make, I know I'm being watched, followed. I have to worry about whether or not my own food is poisoning me! I need to be able to speak for myself. I need to be able to rule – and my job as a ruler is to make peace. The Queen has to see me as an equal, to know that I mean peace now, as I always have. God knows what Wort's been telling her in my absence. Lies. And only I can tell the truth. Only I can perhaps make peace.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Silence fell over us all, a still hush that whispered into quietness. The emerald trees shimmered softly all around us in the faint light. At last Logan nodded, his powerful frame becoming softer, gentler as he realized there was no longer any need to protect me. When we had been children together, he had always been my defender, my guardian. But it was now time for me to defend all of them.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian nodded too, brushing his long black hair out of his eyes. “I don't know what to say,” he said at last. “If I cannot keep you safe in my own house, I will have failed you. I cannot guarantee your safety. The Winter Court is a beautiful place, but it is a cold one. When you were there last you came as an honored guest, and my mother extended you clemency. But that was another time. That was another era. That was when you were a princess, daughter of the Queen's friend Raine, and Redleaf was on the throne of the Summer Court. She didn't see you as an enemy – just an outcast – and anyone who opposed Redleaf, as you and your mother did, was a friend to her. But now you are Redleaf's heir, like it or not, and she has heard by all accounts that you have betrayed her. Wort's lies have doubtless infected her brain.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But I can simply tell her the truth!” I said. “She'll have to believe me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“If you get that far,” said Shasta. “How do you know she won't order your execution on the spot?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'll go unarmed – it would be dishonorable...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And what if she doesn't believe you?” Kian furrowed his brow. “Thinks you're just trying to trick her.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I have to risk it,” I said. “For peace. For my mother and my father.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I sighed as I thought of my father, still lost in the depths of sleep, the result of Redleaf's cruel powers. Would he ever wake up again? I tried to push the question out of my mind. Days ago he had been an image I had barely known – weeks ago I hadn't even known his identity – and no sooner had I met him, begun to feel close to him, than I had lost him again. I’ll have to free him from the spell eventually when I can figure it out. Redleaf was the one to put him under it, she would be the one to break it, but she was no longer here. Yet another complication I had to figure out at Court.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I could feel my face flush hot red with pain, and hoped that the others – especially Shasta – didn't see. She already thought little enough of me for my inability to protect her brother up to now; Kian's escape may have mollified her somewhat, but the last thing I wanted was for her to think I was some weak little crybaby. She looked so beautiful there – as lovely and gorgeous as her brother – with her strong, harsh cheekbones and the layers of dark hair that fell down to her waist. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Why wasn't she Queen, I wondered? How was it that I could be a monarch, and she was still a Princess, waiting in the sidelines? She seemed so much more regal than I was, so much worthier of the crown. I still couldn't help but feel that I had disappointed her, somehow.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I sighed. If I was going to be Summer Queen, I thought, I had to earn that crown, earn that right to wear it. I would bring peace to both kingdoms, be as wise and brave as any of the ancient rulers I had heard stories about. I would make even Shasta proud of me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I am willing to risk my life,” I said, “to do what is necessary for peace.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I saw a small smile creep around the edges of Shasta's mouth. “Your paramour has spoken,” she said to Kian, with a wry look in her eye.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I couldn't help blushing as Kian considered. “I suppose she has,” he said. “I know what this means, then. We must go together – to the Winter Court!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 10")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-w"
  }, [_vm._v("W")])])]), _vm._v("e knew that we didn't have much time. We had to hurry, riding from the fragrant leaves and orange forests of the Autumn lands to the luscious tropical terrain of Summer, making our way to the frozen tundras of Winter that Kian had shown me once before. And yet, as we traveled through the forests and glens, peaks and valleys of Feyland, I couldn't help but marvel at everything we passed. Beauty rushed past us as we hurried along, and with every corner we turned, every cliff we came to the edge of, only to see the vast panorama of Feyland stretching out at our feet, every expanse of land that came onto the horizon ahead of us, my heart and soul ached to stop and stay a while, to let me stare at the land that was mine, to drink in all its beauty. We passed fruits the size of boulders, hanging from long and tangled branches, inviting us with sweet nectar to bite into the aromatic flesh. We passed cliffs jagged and harsh against the moonlight, made white by the night sky, in stark relief to the stars shimmering above. We passed valleys so green that the sky looked white by comparison, and sunsets so rich and bright that the world around us seemed to be, in comparison, made only of black and white.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But as we reached the Spring area, the border between Winter and Summer where so many battles had been fought, we saw ugliness to rival our pain. The fresh rosebuds that had once peeked playfully out of the dewy ground had been lopped off from their stems like so many tiny heads. Bushes had been torn apart to make way from trenches, and the Primrose Path that led from the lily ponds to the Rabbits' Warren was lined with the bodies of fallen fey, stained silver with a river of fairy blood.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I was horrified, but my disgust – visceral and immediate – was nothing compared to the grief I could see on the faces of Shasta and Kian.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Our men,” said Kian. “I recognize some of them.” His face was grim, and I could tell that it was taking all of his effort not to look at me, not to search me with his piercing blue-silver eyes and ask me that unspoken question – why had my people done this to his?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Fairy ")]), _vm._v("blood!” Shasta's voice shook. I was only a half-fairy. My blood did not look like theirs; it ran red. I could not understand the deep, agonizing revulsion that coursed through them at the sight of so much silver. To me it looked alien – strange – a silver river ebbing and flowing through the grass and the buds. To them it was the embodiment of horror.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("As we passed, we saw that the land of Spring slowly turn to Winter – the lightly speckled grass hardening and turning to tundra. The ground froze beneath us, crunching bitterly as we walked and rode, and at last frost appeared, choking the grass into silence. The frost was not clear, as frost was in the mortal world, but rather metallic, shiny. For a moment I thought that the land had been paved with tin.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And then I realized.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It was blood. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Not just a speckle of fairy blood, not just a river, but an icy tundra stained for miles with fairy blood. Summer or Winter – Autumn or Spring – we couldn't tell, only ride through that horrid sea for what seemed like miles. We had been trying to lighten the mood before, with talking and jests, jokes and games, but before this we were silent. Kian and I could not look at each other. Shasta and I could not look at each other. Even Rodney and Shasta, usually so steadfast and sure in their love, were steadfastly avoiding each other's eyes, as if they were afraid that any exchange – even the tiniest one – between them would dissolve into pain, into the realization that his brothers had done this to her sisters, and her men had done this to his friends.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And yet, as we saw the tundra frozen with shining, silver frost, we felt all together that something had to be done. Our parents had caused this – my father, Kian and Shasta's mother – the old generation of fairies had allowed this war to happen. Not anymore, I thought. We had to be the ones to end this, to put an end at last to the death and the pain, the sadness. Had Kian and Shasta lost friends they loved, I wondered? Had Rodney? ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan stood skulking on the outskirts of the group as we rode. It was clear that he felt separate from us. He did not look us in the eyes; he did not stand with us as we mourned. If I felt like a bit of an outsider, as a half-fairy who had not grown up in Feyland, then Logan felt more alien still. These were not his people; these were not his kin or his kind, and he could not share in our grief.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We came across a vale strewn with the silver-coated golden shields of Summer soldiers, my own knights and fairies. The Winter Court must have won a serious battle here. I sighed. I could not resist kneeling, letting my knees sink into the silver liquid, and paying my silent respects to the knights of the Summer Court. “Brave men died here,” I whispered.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We set up camp in that vale, a morbid combination of respect and necessity, for night had come upon us. Logan and Rodney had gone to cook – for in Feyland cooking was the traditional provenance of men. Shasta had gone into the woods to forage for berries and herbs. I was alone, tending the fire we would use to roast our finds. I felt a soft hand caress my cheek, my neck, my shoulders.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kian?” I turned around to see him staring at me, his eyes penetrating through to my pain, my fear.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You were brave to come,” he said. His voice was soft, but strong – fortified with hidden steel. “To risk everything...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I believe in this,” I said. “I believe in peace.” War had separated me from Kian for too long; it had separated Rodney from Shasta, Winter from Summer. If it could only end, if it could only stop, if the blood could only stop running like silver rivers through the streams and valleys of my country, it would be so easy to succumb to him, to let him take me in his arms without worrying, without wondering, if this would be the last time...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian let his hands trail down, his fingers brushing my shoulder-blades, then slowly lingering down towards my wrist, finally brushing against my fingertips. The feeling was electric, a shock of longing coursing through me. I gasped under my breath.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Breena, I never thanked you,” he said. “For saving me.” His gaze was still fixed upon my face, alive with the expression of his love, as hot and dynamic as a crackling fire. “You saved my life.” He took me into his arms, pressing his fingers into my back, releasing the iron-hard tension in my bones. I sighed softly as his lips met mine, pressing all his love, all his adoration, into me. His lips were sweet against mine – tasting of nectar, of fairy fruit – and as his tongue found mine all thought disappeared, so that there was nothing in the world, no war, no pain, only the feeling of his mouth on mine, and his arms wrapped tightly around me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It was only when he pulled away that the familiar fear began – could we do this? Could we survive this war? What if my Court found out? What if his Court found out?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He saw my face – the flush of worry that came over me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It's dangerous,” I conceded. “I'm...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Breena,” he said again. “Before I met you, I knew what my duties were. I would have gone into battle when called to do so, acted without mercy, without regret. I would have spilled the silver blood of my enemies – of your people. It was my duty to kill as many members of the Summer Court as I could. The lines were so clear, then. Winter was Winter. Summer was Summer. Winter was virtuous and Summer was scum. And when I dreamed of you – of a Summer Princess I had once loved as a child – I did what I could to put you out of my mind. I wanted to hate you. I wanted to destroy you – the heir to the throne of my enemies. But as your sixteenth birthday grew closer, as my dreams grew stronger and more vivid – then...” He sighed deeply. “I realized I could not. I could defeat many enemies on the battlefield, but I could not destroy the challenges of my own mind. I no longer wished to shed fairy blood. I never wished to hurt you. From the moment I met you, I knew that my love for you was stronger than my duty. My feelings were stronger than my ability to fight them. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("You ")]), _vm._v("were stronger than I was.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He touched my face lightly, leaving a trail of warmth where his fingers met my skin.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We are meant to be.” He pressed his lips to mine again; against myself, against my worry, I once again succumbed to the power of his kiss. “I know that now. Our love is stronger than magic, stronger than the laws of all Feyland. It will survive this...whatever the future brings.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He motioned to the fallen shield of the Summer knight, crested with silver blood. “Once,” said Kian, “I would have looked at this sight and celebrated: the fall of an enemy, scum, Summer scum. But now I look at this and see only pain: the death of a man with a family, friends, a soul, gone forever from Feyland. And I can no longer celebrate the falling of a Summer knight. I can no longer celebrate war.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I remembered the harsh, cold prince that had abducted me but weeks earlier – the stony-faced soldier whose only goal was to win the Summer territories. He had changed so much since then, his cold beauty warming, thawing, into a dynamic and thriving flame. His solemn face took on the qualities of joy; his love had changed him, set him free. Where before he had stared at me with a still and solemn countenance, now his features were alive with emotion.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We'll get pass this,” I said, squeezing Kian's hand. “I promise. We'll survive this meeting with your mother.” I sighed. “Do you believe in God? I mean – do fairies have a God? Do you know what that is?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” said Kian. “I have learned what humans worship. I have studied the ways of the Land Beyond the Crystal River.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Do fairies have a god?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We believe in a force greater than ourselves – the Ultimate magic. Perhaps it is similar.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Humans – some humans – believe in God. I do – I mean, I always did. And this God...right now I'm praying that He'll give me the strength to do the right thing, to say the right thing, to help your mother understand...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian took my hands in his, warming them as the bitter frost raged all around us. “If you ask this God to help you,” he said, “then I will ask too.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I smiled.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“If I am to marry a half-human,” he said. “I will learn the ways not just of the Summer Court, but also of the Land Beyond the Crystal River. Perhaps, when the war is over, you can take me there – show me around.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Go back home? How strange home seemed to me now. Was it even home, anymore? Did I belong there at all?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Maybe,” I said. “When the war is over. We can visit my mother.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Raine,” he said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, Raine. And Gregory, Oregon. That's where I live.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Gregory.” The word sounded strange in his mouth.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And the woods behind the Gregory High School. Before I came to Feyland, I used to think that the woods behind the school were the most beautiful places in the world. Maybe, in a way, it reminded me of Feyland – an echo of a land I had once known, in a dream, in a distant vision. A Feyland reflection.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“In the midst of Winter territory,” said Kian, “there is an oasis – an orange grove – where nuts and flowers grow. And I used to walk there as a child, and hide there when I was unhappy – and I never knew why. It was only when I came to the Summer lands, when I met you, that I realized. It reminded me of the palace we danced in as children – a palace I didn't even know I remembered...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We've been waiting for each other for a long time,” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian nodded, squeezing his arms tightly around me. “Let us not wait any longer,” he said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 11")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-a"
  }, [_vm._v("A")])])]), _vm._v("t last, we saw the frozen, icy spires of the Winter Palace in the distance, standing up like iron spikes against the vast expanses of the vast, white sky. When I had last arrived here, while bringing home the Princess Shasta, I had been terrified of the place: of the ice-covered walls and stern steel balustrades of a place that I knew counted me as an enemy, ruled by a Queen I had known only to fear. Even now, with the knowledge of the Summer sun deep within my soul, I felt that familiar trepidation. Against all that grandeur I didn't feel like a Queen, or even like a Princess. I felt only like a scared teenaged girl, shaking in my boots and my knightly armor. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("There was no reason to be frightened, I told myself. I would be bringing the Winter Queen good news – news of her son's life and freedom! She would hear what I had to say; she would listen to my calls for peace. She would understand; she would help me. But as I felt Kian's cold hands gripping mine, with something between love and fear, I knew that he was no more confident than I was. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Are you afraid?” I asked him, as the castle loomed larger into view.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No!” He turned his face away, and with that I knew he was lying. A crimson blush appeared over his pale cheeks.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What do you think she'll do?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“My mother?” Kian sighed. “I don't know. You have to understand – my mother have never shown...emotion. It is not fitting for a fairy ruler to show it. It is dangerous enough for a normal fairy to experience these emotions – imagine it! All that magic set loose by emotion, uncontrolled. My mother could never allow herself to feel those things. She was worried about duty. About piety. About honor.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You've never seen your mother act on love? Not ever?” I thought of my own mother, Raine. I couldn't imagine her ever not loving me. Her love was the first thing in all the world I grew to know.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Once,” said Kian. “When my father died – killed by the other army. The Summer Army. My mother went mad. She was screaming, tearing out her hair, beating the walls of the throne room, sending explosions of light and sound everywhere! The other advisors at the court did not know what to do. They'd never seen anything like it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And what happened? How did she calm down?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian gave me a weak smile. “Your mother,” he said. “She was staying with mine – you must have been quite young, for she had only just been exiled from the Summer Court, and was preparing to return to the Land Beyond the Crystal River. She was the only one who understood emotions, who understood rage and pain. She was the only one who could be a friend to my mother. She understood. She comforted her. I know my mother has always been grateful for that.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Even at the Winter Ball a few weeks ago, my mother and the Winter Queen had been friends. I bit my lip and swallowed. Hopefully, the Winter Queen would remember me as Raine's daughter, her friend's daughter, rather than as the Summer Queen, her mortal enemy.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We passed by the frozen moat of the Winter Palace, catching glimpses of the underwater dragons beating their wings against the ice.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Prevents anyone from skating or walking across,” said Kian. “The ice will break, and then the dragons...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He didn't finish his sentence.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Last time I was here, I had escorted Shasta back to the Winter Kingdom in exchange for my mother's freedom, a political ploy that had given us both what we wanted at little cost. This time was different, more dangerous. Even Shasta, normally so confident, was wary of holding Rodney's hand. She knew that the guards' eyes were scanning us – had Rodney been one to kill their friends? Their companions?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("No sooner had we entered the throne room than we heard a voice, loud and clear, but as calm and sedate as morning after a storm. “Kian!” It was the Winter Queen, her pale features thrown into relief by the force of her happiness. She stepped forward, trailing her silvery silk dress behind her. “My son!” She stepped forward again, coming towards us until she was close enough to touch him. She stretched out her hands and for a moment it seemed that her whole body ached to embrace him, to gather his body into hers. But she only placed her hand upon his shoulders, giving him a formal nod as he bowed before her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“My mother.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Welcome home.” She fought the display of her joy, keeping her voice as level as a snow bank, but I could see the happiness in her eyes. Kian had told me that he did not remember his mother ever exhibiting love for him, but her expression made her feelings clear: she had missed her son, and she had been afraid for him")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I caught sight of Shasta's face. Her smile was frozen on, but behind her eyes there was only sadness. Had Shasta's mother ever expressed those feelings for Shasta? If it was Shasta who had gone missing, who had been captured, would the Winter Queen have been so upset? Shasta caught me looking and immediately looked down, freezing her face in a solemn, neutral expression.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And what have we here?” Immediately, the Winter Queen rounded on me, and before any of us knew what was happening the court guards took massive steps forward, surrounding us at the tips of their spears.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The Summer Queen,” said the Winter Queen. “What is she doing here? She has refused my offers to negotiate the release of my son – time and time again – rejected my invitations? And what is she doing here?” She strode up to me, peering into my face with those same penetrating eyes I had loved so deeply in her son. “Since becoming Queen, Breena, did you suddenly lose your sense of decorum?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian and Shasta both stiffened, the color draining from their faces.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You come here now – for what reason? After your letters?” She produced a piece of parchment from the folds of her gown. “The Summer Court will never negotiate with our treacherous enemies the Winter Court. Your son dies tomorrow at dawn. By the seal of the Royal Summer Queen and Empress of the Autumn Territories, Breena the Second.” She let the parchment fall to the floor.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You've got to believe me,” I said quickly, my voice rising. “I had nothing to do with that.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That is your seal, is it not? I take it that those promises of peace you made me at my ball were merely lies.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I never got your message!” I said. “I've been trapped in my own Court – my advisers have been sending you messages without my knowledge, without my consent. I would have released Kian immediately if I could have, but there were spies in my court...it wasn't safe!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“A convenient excuse,” said the Winter Queen. “Now that my son has escaped, and brought you captive. How much easier than if we were to treat you with the same...kindnesses with which you treated my son.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It wasn't...” I started to explain, but the Queen raised her hand, sending me into silence. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You are the voice of your Kingdom, Breena. You are its Queen. You are responsible for your advisors and their actions; you are their leader. If you have allowed them to act without your consent, in your own courtroom, then you are as guilty than as if you had composed the letter by yourself.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I had not expected this. All my protestations seemed to vanish into folly. And yet, with a sickening silence, I knew that the Winter Queen was right. This majestic woman, standing before me, had run a country on her own, fought a war, raised children, survived through it all. And I couldn't even run my own Court. I had run away, like a frightened child, afraid of standing up to Wort and his men. How could I ever have thought that I would be as strong and brave a queen as the Winter Queen, or even Shasta? What would have happened if I hadn't gotten to Kian in time? I would have been responsible.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You are right,” I said. “I am responsible for my actions, and the actions of my court. And it is in the name of peace that I come here today, of my own free will, unarmed.” With this I removed my sword from my scabbard, and laid it down before her. “Kian did not capture me, nor did he escape. I acted in secret, in concert with your daughter, Shasta, to free him myself, because I could not do so through the diplomatic channels. I have been kept prisoner by my advisers, kept in the dark, and thus I came here to speak to you face to face, Queen to Queen, about the possibility for peace. I do not wish to cause more strife in this war, for my people, for your people, for "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("our ")]), _vm._v("people.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The Winter Queen sighed. “I am listening.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“My predecessor was assassinated by a Winter Royal – the people know that much, if they do not know who it was. And my people want revenge. I understand why...this assassin acted.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Shasta shot me a warning look.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I too wished I had the authority to spare the Knight Rodney. But I cannot deny that now my people blame Winter more than ever for the death of the Old Queen. They do not want to fight a war any longer, but they cannot accept a simple release of Kian. Wort and his cronies made sure of that, spreading hate of Winter throughout the land, spreading propaganda. Even those who want an end to war want it on our terms, on Summer's terms. I knew I couldn't simply let Kian walk free. So I have staged his escape. I want peace, Your Highness. And I would never let it come at the price of Kian's life.” As I said his name, my voice trembled, overcome by my love, and pain, and fear.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("At the sound of her son's name, the Winter Queen perked up. “And what do you have to say to this, Kian? You were there at the Court. Is she telling the truth.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian stood up straight, taking a deep breath before beginning his tale. He told of his capture by Summer Knights, of his imprisonment in the Autumn Tower, of the beatings he had sustained by the Summer Guards.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Once again the Winter Queen was a protective mother, rounding on me like a tiger. “You let this happen, Breena? Let my son be imprisoned, treated poorly at the hands of these brutal forces?” Her voice was tight with anger. “You want peace, yet allow the very Crown Prince of our kingdom to be tortured.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It wasn't like that, Mother!” Kian broke in. “The advisors – Wort – they were poisoning her with kelpie soup, weakening her, imprisoning her – she freed me as soon as she could, did whatever she could. She risked her life and her kingdom to save me, disguised herself as a common knight, abandon her kingdom, all to free me from her own men?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“As noble as that is,” said the Winter Queen, “what is to stop me from ending all this right now? Taking her prisoner? Declaring victory for the Winter Kingdom and taking over the Summer lands?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I stopped short. Surely the Winter Queen was an honorable woman – even in the heat of battle, she would not dare execute an unarmed Queen who had come to negotiate for peace. Still, the silence that followed her question was sickening, and I felt a decisive drop in my stomach.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Because,” Kian said quietly, taking a step before me. “Because I love her.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A hush fell over the room, as – one by one – the guards watching us drew in breath, staring us down. I could hear their heartbeats quicken, their stares fix upon us. I shivered.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You love her?” The Queen asked. “So, that is what this is about? A war is being fought – and two schoolchildren worry about their feelings?” She softened for a moment. “Winter and Summer together cannot be, my son.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Why?” Kian's voice rose. “Why not? Two kingdoms – united in peace – under one set of rulers?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And would Winter and Summer ever accept being ruled by their enemies? Being unified? The Winter people would say it was a trap by Summer; Summer would say that Winter was in control.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Then...” Kian looked about the room wildly, as if to find some answer written on the ceiling, on the windows. “Then I'll give up my crown!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A collective gasp came from the crowd.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Why not? Let Shasta rule – she is a better soldier than I am, a better ruler. I'll forfeit my crown and be but a Winter knight, under the rule of the Summer Queen!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Somewhere at the end of the Winter Queen's mouth, I thought I saw a smile starting to twitch.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Your thoughts, Breena?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I can't ask that of Kian, your majesty,” I said. “He would make a great king. I love him too much to let that happen.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But...carrying on with Kian – surely that's an even greater risk? It makes either you or my son look like a fool. And how do either of you expect to keep your crowns if the people find out, and turn against you. There are men like Wort on my side, too – men who would be quick to rouse the people to revolution if they thought they could win them over. Men who could use this information against you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What are you saying, Your Highness?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I am saying – that as a Queen and a Mother, I must ask you both to set this fancy aside. I will release you – out of gratitude for saving my son, and honor at not hurting an unarmed foe – but if I do so, I must ask that you stay as far away from my son as possible, that you never see him again.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My heart seemed to stand still within my chest. And yet, looking into the Winter Queen's eyes, I could see that she was right. What would have happened if my people found out about my mission to save Kian? I could be deposed overnight – and Wort could be installed in my place on the throne...and then peace would never happen.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” I said, softly. I could see surprise flit across the faces of my friends. Kian turned pale, closing his eyes, a small – silent – sign of anguish. “On one condition.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“A condition?” The Winter Queen looked amused. “What is it?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That you sign a treaty with me – a cease-fire against hostilities. And that we begin discussions for peace. I do not want this war to continue past this generation, Your Highness. I want my children – and Kian's – to grow up and rule a peaceful land.” Children that would never be "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ours ")]), _vm._v("I thought sadly"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I see,” said the Winter Queen.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We can tell my people that we negotiated a secret treaty – Kian's life in exchange for the disputed Spring lands. I don't care about the land, one way or the other, but if word gets out about Kian's escape, I'll need to cover it up somehow.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The Spring lands? And what do I tell my people? There are many Winter fairies that live on that land.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We will provide all Winter fairies currently living on that land sufficient money to relocate. You can tell your people that you got your son back – and that you have chosen to give up the disputed territory in exchange for enough money to build new homes for all the Winter families that have lost theirs.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It wasn't anything like a complete peace treaty, but it was a start. The Winter Queen looked surprised, raising an eyebrow as she spoke. “You placed the needs of your kingdom above your own. Perhaps you really are Raine's daughter, Breena Malloy. You are a true Summer Queen. Perhaps I was wrong about you.” She shot me a look full of meaning. “Queen to Queen, I will grant that condition. Perhaps we can finally make steps towards peace.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 12")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")])])]), _vm._v("t had come time for us to say goodbye. In those awful few hours since I had agreed to part from Kian forever, we had not even spoken to each other. We had allowed our eyes to meet only once – by accident as much as out of necessity – and not ten seconds had passed before the agony had become too great to bear and we had retreated into silence and coldness once more. I knew he was not angry with me – he could not be angry with me – and yet his silence felt like anger to me, as cold and raging as fury. Even the slow, soft telepathic connection between us – the sense of connectedness that linked us even when we were in the same room – the sense that we were not two people but rather one ecstatic and indivisible whole, had vanished. I couldn't even feel his pain.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But I could feel mine. I felt as if a part of myself had been cut off, as if there was within my soul a hole so gaping and empty that the whole world could pass through it and still I would not feel a thing.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We had continued the evening in somber silence. The Queen had served us a small dinner – marking Kian's return with none of the pomp and splendor that had defined Shasta's homecoming, and informed us that she had made up beds in the guest tower for all of us; she was waiting for our departure on the morrow. “The next time we see each other,” she said, “It will be when we sign the treaty for peace.” Even in the profound plummets of my misery her words gave me hope. It would be worth it, wouldn't it? If peace could be brokered between the Winter and the Summer Courts, then surely one love, one life, didn't matter? Surely my own pain was nothing compared to the pain of my people – what I would be making them suffer if I refused to leave Kian alone. I knew the violence that would follow our union. Wort would round up his supporters and have me deposed; I imagined some villainous traitor on the Winter side would do much the same. And they would use the war to their own ends, consolidating their power even as people died on all sides, covering the mountains and hills of Feyland.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("At last, after dinner, Kian came up to me and tapped me on the shoulder. His touch was magnetic, sending shivers through me. “Walk with me, Breena,” he said, his voice low and soft with love. “Let us go together. We have a few hours...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Before we were parted forever.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It will only make it harder,” I said, swallowing hard. I didn't want to be reminded of what I was missing, of the man I would never wake up next to, whose children I would never bear. I wanted only to close my eyes, squeeze out the tears, and forget.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We need to say goodbye.” Kian took my hand. “For now.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Don't talk like that...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Maybe one day,” he said. “There will be peace. And then...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We can't get our hopes up,” I said, staring at my dinner plate, feeling the tears in my eyes. “Winter and Summer cannot be. Not ever.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian sighed and offered me his arm. “My mother has said the same thing to Shasta.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I stood up suddenly. “What? About Rodney? But your mother...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That was before,” he said. “My mother feels that she must make an example of Shasta as well. If my love for you is prohibited – and it must be – then she cannot allow Shasta to marry Rodney, either.” He sighed. “My mother knows that I am weak – with love for you. I will not be king. I told her this, in an effort to convince her to change her mind.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“She refuses to allow me to abdicate my position – for Summer's sake as much as for Winter. And yet she knows that if I were to prove....an unfit ruler...Shasta would take my place. She is the one who should be ruling – were it not that my mother favored "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("me")]), _vm._v(", for some reason, she would have been declared the heir apparent. And now Shasta must give Rodney up. If they were married, and I were to...be unable to rule...Shasta could never rule either, and our dynasty would fall.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“She's punishing Shasta for our love!” I cried. “That's not fair.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“She's setting an example.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian stroked my face, his fingertips light upon my skin. “Let's go,” he said. “Just for tonight. Somewhere beautiful – safe – warm. The Snow Orchard.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Where's that?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“As I child, I used to sit there for hours, right outside the palace walls. I want to show it to you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'm not so sure...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Please, Breena,” his voice grew louder, more urgent. “It may be the only chance I ever get.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I could resist no longer. The love, the desire tearing apart my soul was more than I could bear. I allowed him to take my arm, allowed myself to melt into him, to close my eyes and inhale once more his scent of lavender and winter skies as we walked together towards the orchards.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I gasped as we came closer. “Kian, it's beautiful!” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In my old world, flowers could not grow in the snow, but here in Feyland, white lilies and honeysuckle, jasmine and ivy all wound their way about the iron trellises, dusted with snow. Fir trees grew strong against the walls – not tall and thick, as they were in the Land Beyond the Crystal River – but rather long and winding, their fragrant branches tangling in the ivy, snow soft and speckling upon them.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mistletoe,” said Kian, leading me to a spot in the center of the garden. He kissed me softly. “I hear it means something in your world.”  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("His voice was too much to bear; there were tears in my eyes.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Come now,” Kian began kissing my eyelids, making the tears vanish upon the heat of his lips. “Don't cry, stop crying.” He gave a bitter laugh, holding me closer. “Why do you have to be so noble, my dearest Breena?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You would have done the same,” I shot back, my mind instantly racing towards the defensive. “I know you would have. We both believe in peace more than anything else. And it's your destiny to be king of this court, Kian. Not Shasta's – not anyone else's – no matter what your mother might think.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How can I rule anyone – when you so completely rule me?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Exactly, Kian!” I had to make him understand, fight through my pain. “That's why we can't be together. If I take you away, your people will hate you – not to mention mine! I can't destroy your destiny like that.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But I love you!” Was this the stone-faced prince who had once spoken so coldly of duty? “You are my happiness, Breena. Before you, I did not know anything about love. I knew only honor, only death. I never even thought of happiness. And then I met you – and I discovered love...how can you ask me to let you go?” He drew me in again for another kiss, as overwhelming and passionate as the first. I could feel the ground tremble within my feet, awakening the deep magic of his kiss.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I allowed myself to kiss him back, to surrender myself – just for a moment – into his beauty, his love. “I love you,” I said. “And I always will. Nothing can change that. But...” I pulled away, turning to look at the lilies covered in snow. I could not let Kian see my face, the doubt and pain written so clearly on it. “Your mother is right, Kian. Summer and Winter cannot be together right now, not when everything is so vulnerable, so fragile...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian sighed. “Imagine it – one day. One day, when things are different. A unified Court, ruled by a fairy with both Summer and Winter blood. Our child; our heir. Accepted as legitimate by both my people and yours. A single court of fairies.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Our child...” I closed my eyes, imagining a creature with Kian's coltish beauty and my awkward limbs – wearing a double-crown of sun and moon. “Do you think so?” I knew I shouldn't let myself get dragged into this fantasy, let myself cling to hope, and yet I found myself sighing and moving closer to Kian, letting his arms wrap around me once more.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The greatest peace, Breena, the lasting peace. One day – you and I, together. A peace and unification that no treaty can break or un-break. Just all of us, together, in love.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Maybe one day,” I said, my voice dropping to a whisper.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Promise me you'll keep hoping, Breena,” said Kian. “Promise me you'll keep believing.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I promise,” I said. “I won't forget you. I won't forget hope.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I promise too,” said Kian, kissing me again, a final communion of our souls. I felt our telepathic connection spark up again, the overwhelming force that brought Kian inside my head, and allowed me inside his, that bound us so tightly that I could not tell where one of us ended and the other one began.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ahem!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We sprang apart from each other, a guilty blush spreading over both our faces, mingling with the red of our frosty cheeks.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I've been sent to find you.” It was Logan, standing awkwardly in the snow, like a dog with its tail between its legs. He knew exactly where Kian and I stood with each other, but nevertheless I felt embarrassed, even guilty, about being seen with him. I knew how Logan felt about me, and I couldn't stand the thought of hurting him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Here we are,” said Kian, his voice wary. He liked Logan well enough, but when Logan got between him and his love, he could be very dangerous. “What is it?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan cleared his throat. His face contorted with worry. Kian and I both stopped short. It wasn't jealousy that had led Logan to pay this call. He had come for a reason – something serious.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What is it, Logan?” I asked again.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He took a deep breath, sighing in the frosty air. “It's Shasta.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 13")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-w"
  }, [_vm._v("W")])])]), _vm._v("e sped down together along the frosty corridors of the castle. Icicles glinted menacingly at us from the arches, and from the candles lining the halls there glittered silver frames. Logan remained silent, his teeth clenched, his shoulders tensed, as he walked on before us, his animal steps echoing down the halls.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What's going on?” I asked. “Logan, what's happening? Where's Rodney?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian tensed his grip around my waist. I could feel his pain, his fear. But Logan continued walking onwards, refusing to look at either of us.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wolf!” cried Kian. Logan stopped short, and when he turned around I could see that the words had stung. “Do you mind telling us what happened "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to my sister?” ")]), _vm._v("His voice was thick with disdain; now that Kian and I were to be parted, he could no more afford to be generous to his rival.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan's face was white with anger. “While you were idly passing the time in your flowery little orchard with...with "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("her")]), _vm._v(", Your Highness” - and his words were filled with as much venom as Kian's condescending “Wolf!” - “your sister tried to kill herself.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian blanched. “What? What are you talking about?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I thought of Shasta – so strong, so brave, so sure that she was in control. How could she, of all people, have succumbed to despair. “That's crazy! Shasta would never do anything like that...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“While you two were worried about your own relationship, your sister – your "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("engaged ")]), _vm._v("sister, who has known Rodney for far longer than you two have known each other – was saying goodbye to the man she thought she'd marry.” Logan scoffed.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It's true then,” said Kian. His voice was thick with bitterness. “Love is deadly for fairies. It's what we were always told growing up – love is dangerous. When a fairy falls in love, and it affects his magic – or her magic – it spirals out of control, like a ball of fire. And Shasta was so strong...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kian's right,” said Logan, in a voice that made it clear he hated saying those words more than anything in the world. “Remember how irrational Shasta was when Rodney was kidnapped? She killed Redleaf, for goodness's sake! She let herself be captured by your court in order to get closer to Rodney. If she hadn't done that, Kian would never have had to go find you in the first place, go into the mortal world...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He stopped short and I sighed. It seemed so long ago that Kian was my enemy – the cold, brave soldier who had kidnapped me to save his sister's life. Looking into his eyes, seeing his pain and his compassion for his sister, I could not imagine this kind, brave man ever being anything but my closest friend.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“If Shasta had not killed Redleaf,” Kian admitted, his eyes half-closed with despair, “peace would have come so much more swiftly. And yet I cannot bring myself to blame her. She followed her heart, her love, her loyalty to Rodney.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Your sister got fairy knights – like Rodney's brothers, his friends – killed! How can you, of all people, defend her? You who pretend to care so much about your kingdom, about peace.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“She is my sister,” said Kian, shortly. “I will defend her regardless.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("As we entered Shasta's room, a deathly quiet fell over us all. Shasta was lying in her bed, swaddled in white cloth, her face as pale as the silk surrounding her. Rodney was kneeling by her bedside, pressing his face into her. The Winter Queen stood firm and tall at a corner of the room, regarding her daughter from a distance.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mother!” Kian's voice had grown colder, more regal. He bowed to her with an impeccable imperial salute. “What has happened?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She looked at him coolly, giving a great, deep sigh. “Shasta would not accept her destiny,” she said. “She tried to take poisonwood nectar. If I hadn't found her in time...” Her voice was level and even, betraying no sign of emotion. I couldn't help thinking of my own mother. If it had been me in that bed, she would have been distraught, overcome with madness. But the Winter Queen only stared straight ahead.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You okay?” I went to Rodney, patting a hand on his shoulder with as little awkwardness as I could muster. But he did not hear me. He remained curled up at Shasta's bedside, murmuring her name into the sheets.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The Winter Queen turned her gaze once more to Kian. Was it a trick of the light, or did I spot some worry in her eyes? “She would not accept her destiny,” the Queen said again. “She did not understand her duty.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian sighed. “Will she be alright?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“She's in a coma,” said the Winter Queen. “She will recover – but the situation is critical.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian took a deep breath, stepping forward to Shasta's bedside. He took Shasta's hand, cradling it in his as he closed his eyes. “I can hear her,” he said. “Her body has been injured, but her mind is strong. Her heart is strong. Perhaps too strong,” he said, shooting a look at Rodney. He leaned in close to Shasta, whispering something in her ear.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Suddenly, Shasta sat up, as straight-backed as a spear, energy pulsing through her body. “You wouldn't!” She cried. “You won't.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A silence fell over the room, broken by Kian's slow, gratified laugh. “I knew that was going to wake you up,” he said, forcing a week grin in Shasta's direction. “Not even poisonwood nectar can stop my sister from correcting me when I tell her that if she dies, I'll be a much better ruler than her.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Shasta flushed, and all eyes turned to the Winter Queen. Her surprise – registering for only a moment on her face – had faded, giving way briefly to a blossoming of joy before vanishing altogether, leaving only her regal expressionlessness on her face. “You gave all of us a fright just now.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Shasta stared straight ahead, as if trying to pierce past all of us with her eyes. “Because you'll miss me, mother, or because you'll be deprived of a potential heir?” Her voice was shaking, but her familiar disdain was clear. “Everyone knows that without Breena, Kian won't be able to rule. So I guess that leaves me, mother. Once again to suffer for Kian's sake.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It's not like...” Kian protested.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, it is,” said Shasta sharply. “Mummy doesn't want her precious Kian to suffer by himself – so I must suffer too, isn't that it? Well, let me tell you something – even if Kian doesn't rule, I won't either! I'll abdicate the throne, give it to one of our dozens of second cousins. I'm not giving Rodney up, Mother. I'll abdicate. I'll leave the Kingdom. Or I swear, next time I drink poisonwood nectar, you won't find me in time.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You won't!” Rodney had stood at last. “I can't let that happen.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Rodney, please!” Shasta let out a deep sigh. “I have to do this! I won't lose you!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rodney's eyes filled up with pain. “I love you dearly,” said Rodney. “But I can’t let you risk your own life and health – your own self – for me. No, Your Highness, not for me.” He stood, his back straight and stiff. “If your love for me drives you to that, then I will have no part of it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Tears began streaming down Shasta's cheeks, torrential rivulets of silver. “But Rodney,” she whispered. “I want you. I want you more than I want to be Queen.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I couldn't help catching Kian's eye at this point. Shasta and Rodney were playing out before us our own feelings, our own desires. Just as Shasta would sacrifice herself for Rodney, so too did Kian and I long to sacrifice ourselves for each other, to escape to a land where we could be together, in love, forever.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“If anything happens to Kian,” Shasta repeated, taking deep breaths. “Then I will have to become queen. And you know how much your precious son loves Breena! Who's to say he won't abdicate in order to be with her?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“He won’t!” I heard myself cry out! If Shasta and Rodney had to be brave, to give up their desires, then surely we did too. It was the honorable way. “If it comes to that, Your Highness,” I turned to Kian's mother. “I wouldn't accept Kian's love. Not at that price.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I could see Kian flinch. “I have accepted my duty, Shasta,” he said softly. “I will fulfill my destiny to become the King of the Winter Kingdom someday – hopefully,” and here he looked at his mother, “a long time away. You need not worry about what is or is not your duty, Shasta. You will never have to become Queen if you don't want to; I promise. You can keep Rodney, as far as I'm concern. You're my little sister, and your happiness is more important than mine.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Did you hear that, Mother?” Shasta's voice rose with defiance. “Why should we both suffer?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“My hearing is perfect.” The Winter Queen's voice was like ice. “But that doesn't change anything. That doesn't change who you are. What your duty is!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No,” Shasta whispered. “No – that's not fair!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You have been a disappointment to me, Shasta.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Shasta let out a whimper, so much more vulnerable than her usual snorts of disdain. “But Kian will be king, mother. You won't need me here. Can't I be happy, mother? Why won't you let me be happy?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The Winter Queen turned away. “Perhaps the Ancients were wise,” she said, “in banning love from this kingdom. Look, Kian, what it has done to your sister. Before she succumbed to this infatuation for this...Summer knight, she was so eager, so graceful, so clever. So willing to learn about all that was necessary to become a good ruler, a sovereign of the illustrious Winter Kingdom, to take on her role as Princess. She used to cry to me at nights that Kian was to be King, that she would not rule. She would beg me to give her the crown! And now look at her! Weak, unpredictable, passionate. It is what I have always feared – as a mother, and as a Queen. An emotion as human as love poisoning our very beings.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mother!” Shasta protested. “There is nothing wrong with...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The Winter Queen put up a hand to silence her. “You are blind!” she said, her voice bellowing, echoing throughout the icy halls of the castle. “You are blind.” The Winter Queen's voice grew harsher; I could see every word land with a sting on Shasta's milk-white face. “Have you forgotten – you killed the Summer Queen out of your passion? That is why Kian was imprisoned, why he was almost executed. Passion started this war – Redleaf's jealousy that caused it in the first place. Passion continued it. All these emotions – greed, lust, desire, out of control!” She turned around, staring us all down, her face more majestic than ever. “Therefore I must take drastic actions, if I wish for peace, for any of us. I declare that there will no longer be outright love in the Winter Kingdom. It is dangerous. It is deadly. No fairy – peasant or princess, common or Queen – will be allowed to love. Marriages will be arranged – and any relationships "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("banned")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mother!” Kian's voice was full of warning. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, Kian!” The Winter Queen waved him away. “Look at what it has done to our family already. It has weakened us. Our family – our kingdom! Look at you, ready to just throw away thousands of years of imperial rule so that you can follow some girl into a court of strangers! Look at Shasta – if you can! If shame does not prevent you from even looking at her!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Shasta's face fell. “I can't help it,” she murmured, in the small, kittenish tones of a frightened child. Even the imperious Shasta was a little girl before her mother.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Have you seen the fields colored silver with our fairy soldiers' blood, Shasta?” The Winter Queen still would not look at her. “I didn't want this war. I didn't want this pain. I didn't want to lose my husband on the battlefields of the Spring lands. They attacked us first – the Summer Court – yes, Kian, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Breena’s ")]), _vm._v("people. They came into our land. They came into this very palace. Your father was the first to die! And you want to wave away all that pain, all that guilt, because you are selfish. You can help it, Shasta. You just don't want to.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You just didn't want to end the war either!” Shasta said. “Because you missed Father so much, you let your own emotions get the better of "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you!”")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She was silenced, suddenly, by a strike across the face – the Queen had slapped her. Hard. “I did my best to broker peace,” the Queen said, white-hot rage bubbling within her. “Before your father died, we hoped that a royal engagement would cause unity. But too much blood has been shed since.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Shasta leaped to her feet. “There will be more, mother,” she said, her eyes blazing. “I swear it. If you don't let me go with Rodney.” Out of the folds of her tunic she produced a dagger, glinting and sharp. She held it to her throat, her eyes alive and dangerous. “Mine.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 14")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-t"
  }, [_vm._v("T")])])]), _vm._v("he Winter Queen refused to show any emotion. “Put the dagger down, Shasta,” she said. Her face was still, as expressionless as the surface of a pond.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I mean it, Mother!” muttered Shasta, through clenched teeth. Rodney and Kian had sprung up, standing – tensed with terror – beside her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Shasta!” Rodney cried, but she would no longer look at him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I took a deep breath. My mother had always told me that the most important thing to do with a hysterical person was to keep them calm and comfortable. I took a small step forward. “It's okay,” I said. “It's okay, Shasta. Don't panic. We'll figure this out – I promise. Put down the dagger. I know how you feel.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You!” Shasta brandished the knife at me. “Have no idea how I feel!” Tears were dropping onto the floor-tiles, now, as she placed the knife once more against her throat. “Take one step closer and I'll do it, I swear!” She pressed deeper, and a single droplet of silver blood appeared at her neck. I stopped short, taking a look around me. Rodney and Kian were both frozen in horror; the Queen stood immobile, impassive. She hadn't even flinched. Was that the sort of mother that Shasta had grown up with?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“If this is your way of getting what you want,” the Queen said, “like a spoiled human child throwing a tantrum, then you are mistaken. I certainly don't wish to indulge you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Desperation flitted across Shasta's eyes. She was crazed, like a wild animal that had been caged, beating itself against the walls of her prison, trying to find a way out, some way out. “Rodney!” she choked out.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Shasta!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“If I can't be with you...then I don' want to go on...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No!” As she had raised the dagger, ready to plunge it into her own breast, Rodney had rushed towards her, covering her body with his, throwing himself between her and the fatal blow.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Rodney!” Shasta screamed. “Rodney!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She stepped away, her hands silver-stained and clapped over her mouth. Rodney lay at her feet, the knife deep within his chest.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I didn't mean...I didn't mean to...” Shasta crumpled to the floor, her screams echoing in all our ears.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Shasta...” Blood was pouring from Rodney's wound, trickling from his mouth. His eyes were glazing over, disbelief still written plainly across his gaze.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hurry!” I shouted, to nobody in particular. “Somebody – get a doctor!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The wound is deep” - in a matter of moments the Winter Queen had glided across the room, and she stood now at Rodney's side.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I didn't mean...” Shasta was choking out words. “Help! Somebody help him!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Get a doctor!” I cried.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“There are no doctors, you fool!” Shasta was screaming at me. “Fairies don't have doctors! We heal...we heal ourselves.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rodney didn't look like he was about to heal himself anytime soon.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Then do something!” I couldn't help shouting back. The sounds of Shasta's cries were still ringing in my ears, mingled with Rodney's soft groans and Kian's attempts at binding the wound.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We can't!” Shasta wailed, clutching Rodney in her arms. “Not when he's so far gone...” She held him even more tightly, covering his face with kisses. “Only you can!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Me?” I stopped short. If the powerful Winter Queen herself could only stand there, her face stone-still, then what could I be expected to do?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“This is a life force you are restoring,” said the Queen softly. “It is a very significant matter. But our magic – it is Winter magic. It would have no effect on a Summer Knight such as Rodney. We are bound by our old ways, you see.” I thought I could detect a grim smile at the edge of her mouth. “We have no choice but to cede you the floor.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I don't know how to heal!” I shouted back, but even as I spoke I felt that this wasn't true. I felt a golden warmth deep within myself, close to my heart, a warmth I had not felt before, but which felt nevertheless familiar, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("right")]), _vm._v(". It was the power of the Summer Queen, my birthright, my heritage – the power to heal the fairies of my land.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hurry!” Shasta said again, her knuckles white with tension as she clutched at Rodney's hand. Silver was pouring from the wound, pouring out of Kian's shirt, which he had torn and tied to stop the damage, trickling from Rodney’s mouth. Rodney looked up at me, his fading eyes full of hope. I was his last chance – Shasta's last chance. I had the opportunity to save him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I swallowed hard. This wouldn't be easy. I'd never used magic to heal anyone before; I had no idea if it would work or not.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You can do it, Breena,” said Kian softly. “Concentrate. Summon the healing magic.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I saw them all staring at me – all their eyes on me – and I looked down. They all expected me to be able to fix this situation, to make it all better, to save Rodney's life and Shasta's sanity. And what if I couldn't do it?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("No, I wouldn't think of that yet. I couldn't imagine letting them down.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I took a step forward, placing my palms outwards. “Like this?” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The Winter Queen nodded. “Lay your hands on him.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I kneeled at Rodney's side. “It's going to be okay, Rodney,” I said, unconsciously of myself. “You're going to be fine. I promise.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The promise of a Summer Queen who didn't even know how to work her magic!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Slowly I pressed my palms to Rodney's wound, seeing my hands grow wet and sticky with silver blood. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Please")]), _vm._v(", I whispered, to the golden force I could feel throbbing inside me. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Please work. ")]), _vm._v("The warmth grew larger within my chest; my lungs expanded with a honeyed heat. I tried to focus on things of summer – warm, fresh bread baking, memories of California, where my mother and I had gone when I was a child, the beach with piping hot sand and cool California breezes, the taste of salt on my tongue.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The force grew larger, and then it vanished.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("No!")]), _vm._v(" I closed my eyes and tried again, concentrating once more. My eyelids grew hot; my body grew hot; I thought once more of fertility and growth, of life, of my people – the ones I had sworn to save when I took the crown. I thought of the orange gardens at the Summer Court, the smell of sweet bergamot, the miles and miles of wheat fields in my country, which fed my people and kept them strong, the fruit trees ripe and dripping with nectar, the animals – babies at first, then strong and proud adults – growing and thriving in my land, the endless dynamic force of consumption and rebirth – the grain giving its life for the deer, the deer giving its life for the hunter, at once destroyed and eternal, as the life force in the tiniest seed expanded and grew, until my people were fed, my people were well, and all of life thrived in my beloved kingdom.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My eyes shot open, and I could see golden sparks emanating from my fingers. A mist of healing soft amber flames shot out of my fingers in swirls. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Here goes, ")]), _vm._v("I thought, and pressed the fingers to Rodney's wound.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He screamed, and for a moment I thought something had gone wrong; for a moment my heart leaped with fear. But then I saw the jagged edges of his wound moving, flowing into each other, the skin growing over the damage like the sea covering the sandy shore. The silver was vanishing, turning into a healthy gold, a gold that merged into his skin – as tanned and strong as he had ever been. I could feel the life force within me emanate from my fingertips, my vibrancy, my vitality, all sapping even as the connection with Rodney grew stronger, as his strength gave color to his cheeks and life to his eyes. He wasn't just alive, he was thriving, consuming the life force itself, the ancient magic that somehow I possessed and had yet given away.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With a final, overwhelming, push I was thrust away from Rodney, falling into a series of bruises on the cold metal floor. Rodney was sitting up, looking at himself with wonder, with awe. He looked not only as if he had been healed, but also as if he had been revitalized– younger, more handsome, stronger than before. His eyes were brighter, his hair fuller and shining with sparkling copper lights.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I, for my part, could not move. Whatever life force had been given to Rodney had come directly out of me. My skin felt cold and clammy; my hair had gone limp; I could feel my cheeks go pasty and pale. I barely had the strength to sit up.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Breena.” Kian rushed to my side, propping me up as Shasta began kissing Rodney's hands.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'm sorry,” she was whispering. “Rodney, I'm so, so sorry.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Shh,” he whispered, stroking her hair. “We'll talk about it later.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Even the Queen, standing in the center of the room, seemed relieved, although she would not show it. But I could see the relief in her eyes, the happiness she felt at her daughter's own joy – a joy that had seemed impossible only seconds before.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Thank you, Breena,” she said, and in her voice there was pride as well as gratitude. “You have done my daughter a service.” She immediately resumed her former posture. “I am sorry to have put you in such a position – and to have embarrassed you in such a way.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No embarrassment at all,” I said. I would have curtseyed, but my legs were still feeling too week. “For nothing happened. Nothing at all! At least – nothing anyone would ever hear about from me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Your discretion is valiant, Summer Queen,” said the Winter Queen. “It will serve us well in the peace talks.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My heart leaped a little. Peace talks. Despite the intensity of what just happened with Shasta and Rodney, I was grateful the result had sealed the Winter Queen’s promise about the peace treaty. “That's my only goal,” I said, turning one last, longing look at Kian. “That's all I care about.” Suddenly, I felt even weaker and more exhausted than before. Pain overwhelmed me, and I couldn't help doubling over, weighed down by my grief. If giving up Kian would bring peace, then this pain would be worth it.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Are you all right?” The Queen shot me a look of concern.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Fine!” I lied, although tears had begun misting my eyes. “It's just the spell – that's all! Just the spell.” I looked down at the floor, afraid that they could all see right through me, knowing my pain, my love, my desire.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Then we're sorted,” said the Queen. “On the morrow, you will return home to your kingdom, and Kian will stay in his, and together we will stride forward with the peace process.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“As you wish, your Majesty,” I whispered. But my heart felt as cold as the parapets of the Winter Palace.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_vm._v("Chapter")]), _c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_vm._v(" 15")])]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-m"
  }, [_vm._v("M")])])]), _vm._v("orning had come, and it was time for Logan and me to leave the Winter Palace once again, and return to the land of Summer. I should have been happy, even proud. I would return triumphant to the Summer Kingdom, on the galloping golden steeds the Winter Queen had given me as a peace offering, holding in my hands the magical deed that pronounced Summer the ruler of much of the occupied Spring territories. The Winter Queen and I had discussed a plan – I would claim the vanished territories for Summer, and then return through the front gates of the city. The news of peace, and of the return of our lands, would travel quickly through the main city, and before Wort had time to respond, the people would be cheering me, acclaiming me, repeating that I was their beloved leader. And there was no way Wort could seize power without looking suspicious. Rodney would have me escorted by a number of loyal Summer guards we would pick up in the villages of Spring. The plan had all been decided.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And yet I couldn't bring myself to feel happy or excited. As the two suns of Feyland began peeking out of the sky at opposite ends of the horizon, I did not feel joy. I felt only pain, the inevitable knowledge that Kian – in the next room, perhaps, or down the corridor – would never be so close to me again. All my love, my pain, my passion were to be sacrificed for something greater, and yet I could not convince myself that I had made the right choice.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Maybe, I told myself. Maybe when all was said and done, when peace had been enacted, when we had ruled our kingdoms for a while, there would be a chance for Kian and for me. Or would he be required to marry someone else, to have an heir? My heart froze at the thought of Kian with another woman, crowning another woman his Queen. But I knew that Kian's mother held all the power in Feyland, and I had no idea what she would do to ensure that Feyland stayed safe and under Winter's control. I wouldn't put it past her to insist that Kian marry – and soon!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I couldn't sleep all night. I stared out my window, at the pale pink horizon where the Summer lands began, trying to muster up my pride at the way the sky shone scarlet and orange and alive with the burgeoning break of dawn. It was not like the blue and ash-gray dawn of Winter. There was sun in my land, golden sun! And yet it was no use. I wanted to stay here, in the cold, in the shadow of Winter's white, icy sun. Wanted nothing more than to throw my crown to the winds and stay with Kian forever, in his palace, in his arms.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("No, I couldn't do that. I shook my head, trying to rouse myself from these thoughts. I couldn't sacrifice my birthright that way. Not only did all those citizens of the Summer Court rely on me – although that was a big part of it – but "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I ")]), _vm._v("relied on me. Somehow, over the past few weeks and months, being Summer Queen had become part of who I was, part of my identity. I felt the magic of Summer course through me – when I had healed Rodney, when I had hypnotized the guards to save Kian. Turning down the crown now would be like giving up a part of myself.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("These thoughts continued to occupy me when I heard a knock at the door.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Who is it?” I tiptoed across the room, feeling the sharp, cold marble nip at my feet.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I opened the door. Logan was standing there, gruff and grim. “It's time to go,” he said, not looking at me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Poor Logan. Since we had rescued Kian, I had hardly spared a moment for Logan – I had, I knew, ignored him in favor of my beloved. I flushed with shame. He had been my best friend, after all.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We should go quietly,” said Logan. “The Winter Queen doesn't want any more fairies knowing that the Summer Queen has been here – it could be dangerous for both sides.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I understand,” I said. I had adopted the neutral garb of a fairy peasant – neither obviously Summer nor obviously Winter. The Queen had presented me with a splendid golden robe – a Summer gift given once upon a time by my mother – into which to change when I arrived in the Summer lands. But for now, anonymity was key.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Rodney's waiting at the stables,” said Logan.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Is he okay?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan gave a curt nod. “I talked to him last night,” he said. “He's pretty upset, but physically he's fine. You did a good job of healing him, Breena.” He clapped a hand on my shoulder, trying to tease me like in old days. But things were different, now. Without realizing it, he allowed his hand to linger on the side of my neck, caressing my skin softly with his fingertips before realizing what he was doing and awkwardly, painfully, jerking it away.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And Shasta?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Shasta's locked herself in her room,” he said. “She accepts her mother's wishes – for now. But I guarantee that before long she'll find herself with Rodney again. I don't think anyone could stop Shasta from doing what she wanted. Not even the Winter Queen herself.” He gave a wry laugh. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We headed out to the stables. The dawn was gray and silvery, here, and the white sky vanished into a horizon formed out of white snow.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Should be about a day's ride from here,” said Logan, staring out at the colorful dawn that marked the Summer Kingdom.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I want to go through the Spring Pass,” I said. “And claim the territory. The Queen's treaty – here – she's signed it. It should return the land to us.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Does this mean the end of the war?” said Logan.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Not yet,” I said. “But soon. This part of the Spring Pass has some of the worst fighting. Thousands of Summer fairies have lost their homes, their livelihoods. Now they'll get to return.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You did good, Breena,” said Logan. His cheeks were turning red, and it wasn't entirely because of the cold. “You made a big sacrifice, I know that...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It was nothing!” I cut him off, a bit too sharply. The last thing I wanted was to talk to Logan about Kian. It hurt badly enough already without me feeling guilty, too. And I couldn't talk to Logan about Kian, see the pain in Logan's eyes, without guilt.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Giving up the guy you loved...” Logan was pushing the issue now – as if to punish himself, remind himself of the fact that he and I would never be.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I told you,” I said. “It was nothing!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sure,” he said, sighing and turning away. “Nothing.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Before we could continue the conversation further, we ran into Rodney, leading three grey-speckled horses out of the stables.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ready?” His voice was grim; his body and face alike were steeled with resolve.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We grabbed hold of the horses' reins. I sighed, trying to take in for the last time the imperial facade of the Winter Palace.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wait!” Rodney cried. “Who's that?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It was supposed to be secret...” Logan hissed, as we caught sight of a figure in black making its way towards us. “You didn't tell anybody, did you?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No!” Rodney protested, but I wasn't worried. Even before the figure came into full view, my heart told me who it was.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kian!” I cried, rushing towards him, leaving clear, dark footprints in the snow.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He strode towards us swiftly. “I have come to say farewell,” he said. “To all of you.” His eyes were dark and full of pain; beneath them, swollen, dark eyelids told the story of a sleepless night. “Logan,” he said. “A sword from my father's collection. To protect you. And for you to protect her. Despite our differences, I trust that you will protect her with your life.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan nodded, his ears turning scarlet.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Rodney – some food for the journey. And a message from my sister – a letter. I have not read it; I trust it will be useful to you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Thank you.” Rodney looked down, slipping the letter into his pocket to read later, in private, when it would not be seen as weak to weep.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And...Breena.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian looked around, as if seeking out some hidden glen, some corner, where we could steal away and get some privacy.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'm here,” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Come with me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian led me only a few paces off;, but in the mist of the early morning, it felt as if we were in the middle of nowhere – Rodney, Logan, and the horses all vanishing into the surrounding snowfall.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I don't ever want to say goodbye to you, my love,” said Kian, pressing me tightly into his arms. “Not now, not ever.” His voice was heavy with emotion. “I can't say it now.” He pressed his lips to my cheeks, my ears, my forehead. “Last night – what Shasta did...” his voice choked and trailed off. “Sometimes I think it's not so far from what I would do...if I lost you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I smiled against myself, pushing Kian away lightly with my fingertips. We had to stay strong, now. “No, you wouldn't,” I said. “I know you. You'd be a strong king, a brave king.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“A king without a queen.” Kian sighed, breathing mist into the air. He held me tighter, kissing me with a heat that seemed to thaw the very snow on which we stood. “You don't know me as well as you think you do,” he said. “What I'm holding back. What I'm capable of. You haven't felt it – how much I love you...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My mind flashed back to those nights we had spent together in his hunting lodge – the heat of his kiss, the passion that had overtaken us both. How much there was still left for us to learn about each other!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I want so much, Breena,” Kian was saying. “And I want it with you. I want to be with you one day.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“One day,” I said back. “I promise. We'll be together.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I can't wait.” Kian pressed my hands to his lips. “I love you with all my heart, all my being, all of myself. Whatever my mother says, whatever the laws says, you are still my intended. I can feel it. Feel it the way I feel the power of Winter Magic in my blood. It is a truth more ancient than any laws, any magic. We can still communicate telepathically, with our minds, which is one magic of love. When you have love for someone, and it is returned, lovers can communicate through the mind – as long as we have that connection, we will never be truly parted. Promise me that, Breena.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I promise,” I said. The tears trickling down my cheeks were freezing on my skin, like tiny snowflakes. Kian brushed them aside, and they fell to the earth, shattering, each one like broken glass. Kian open his palms and cold blue flames appeared at the edges of his fingers. The flames danced higher, swirling itself around my body from the top of my head to my toes. Despite the coldness of the flames, I felt warmth, cold heat, the magic of Kian’s love enveloping me, searing through every cell of my body and my mind, stronger than our first kiss. Finally, it stopped, and I opened my eyes.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian was flushed, feeling what I had felt. But his eyes looked tired as though the magic had exhausted him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Not goodbye,” said Kian.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, never goodbye.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan cleared his throat, and we knew it was time for us to part. With one final, longing kiss we bid each other our last not-farewell, and then I mounted my steed, wiping away my tears and staring ahead at the hot-pink horizon of the Summer Court.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We were off.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 16")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-t"
  }, [_vm._v("T")])])]), _vm._v("he ride to the Summer Court was an exhausting one. The three of us spent hours in our saddles, pressing on ahead to Spring Pass, where more of Rodney's men were waiting for us. Rodney had sent out a messenger pigeon just as we had left at dawn, attempting to contact the bravest and most loyal soldiers he knew, and by the time the Spring sky was high overhead, and the ice of the Winter Court had given way to a pleasant, flower-scented breeze, he received an answer. The knights of the Summer Court had feared and despised Wort, and were more than happy to escort their rightful Queen into the Summer Court.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I knew it!” Rodney says. “There's no way any noble Summer soldier would trust Wort. Apparently he's been telling everyone that you're ill inside the castle – and running things for you!” He handed me the letter. “Wort's been telling everyone that you fully support war with winter – that you want to escalate it and take over Winter altogether!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That blackguard!” Logan said. “Who does he think he is – that he can rule over the whole kingdom like that?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“He's not a fairy,” said Rodney. “At least – that's what the rumor is. No fairy could be as devious as that.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Yet Wort seemed much less important when we reached the pass. As we navigated the treacherous roads leading us between the two great mountains that led into the territories of Spring, we stopped short; I couldn't help gasping. Spread out before us in a gleaming, glittering mass were what must have numbered thousands of Summer Knights, all in golden armor, raising their shields and lowering their swords.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They had come to fight for me, to defend me, to proclaim me their Queen. I felt my heart begin to beat faster and faster within my breast. Though only hours earlier I had felt far less like a Queen than like a little girl – heartbroken and selfish – their confidence in me, their faith, gave me strength.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“All Hail Queen Breena,” they shouted in unison, “All Hail the Summer Queen!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That's you!” Logan turned to me with a grin.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We rode onwards, as the soldiers parted to make room for us. I took the golden robe from my saddlebag and put it on, feeling the power of summer course through me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("One by one, the knights dismounted their horses and began to kneel, a ripple of light that spread out for miles behind them.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("This was it. This was my moment. “I am here,” I shouted, “to bring peace to Feyland at last.” My voice carried across the crowd, buoyed out by magic. “I have just returned from a diplomatic visit to the Winter Court.” I searched once more in my saddlebag, my fingers finding the treaty that the Winter Queen had signed. The crowd had gone silent with surprise.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tonight, you will go home to your families,” I said. “The war with the Winter Court will be at an end. I have signed a cease-fire last night, and there will be an end to hostilities.” Everyone gasp, a single, dynamic motion that sounded like a collective gust of wind. “The Winter Court has ceded to us all territories east of the Spring Pass.” I dismounted my horse and placed the treaty on the ground. “I claim this land for the Summer Court!” I said, striking my sword to the treaty as the Queen had taught me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Instantly, the piece of parchment began glowing – gold and silver mingling to create a single, pure white light that swept through the kingdom. Suddenly, the land itself began to shake, shimmering as if a mist had taken hold of the entire territory. At once, the power of Summer began to take over. The trees – desiccated and dead with warfare – began to spring new life; fruits appeared on long-withered branches, and green grass burst from the earth which had previously been covered in silver blood. The mountains were at once covered with moss and vines, and the sun seemed to shine brighter than before. Winter's presence had vanished from the land, leaving in its stead the full heat and force of summertime.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I could hear a cry of joy come up from the crowd – my men! Tonight they would see their wives and children, their sisters and brothers and parents, and war would at last be at an end. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“All Hail Queen Breena,” the cry went up again. “All Hail our Summer Queen!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Together we marched through the woods of Feyland, at last restored to their former beauty, until we reached the very gates of the Summer Court's capital city. The gates of the city gleamed as the sun sprinkled its sparkling light upon them; the very cobblestones of the road seemed to shimmer in delight. And so we trailed onwards, a mile-long procession of brave men and women, with me, Rodney, and Logan at the head.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A trumpeter let out notes of triumph as we reached the gate.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Behold the return of the Summer Queen!” one of the soldiers shouted. “She has come to free the city from the machinations of the traitor Wort.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I caught sight of the fairy operating the drawbridge, his eyes wide with surprise. “I thought the Queen was in there!” he gaped. “In the palace, sick!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“She's right here,” said Logan, his voice brimming over with pride. “And she's brought peace! We signed a cease-fire last night; the war is ending – the Spring Pass has been returned to us!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("By the time the drawbridge was let down, the news seemed to have spread to half the city. As we processed down the main avenue, thousands upon thousands of fairies had already left their homes, their schools, their shops to come see the grand parade, standing on street corners, repeating the same shouts of joy that the soldiers had let out before:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“All Hail Queen Breena; all Hail the Summer Queen!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I could hear whispers and shouts: “Peace at last!” “The Spring lands returned!” “We'll be able to go home again!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The snowy tundra of the Spring Lands has turned once more to ripe fruit and lush greenery!” I said, and a cheer rose up from the crowd. To emphasize the victory, I decided to use the name most of the Summer denizens have come to call the Winter Queen...the Snow Queen. “The Snow Queen has surrendered these lands to us!” That she had done so because I had released what the people thought to be Redleaf's killer I decided to conveniently leave out. “We have won the battle!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We marched up to the very gates of the palace. Wort had evidently not been taking the best care of it in my absence – the orange groves and flower-gardens looked parched and desiccated, like fruits left out too long in the sun.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I hear you have been told that I was ill!” The crowd roared in assent. “But this was a lie, told to you by the traitor Wort!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The crowd began to boo and hiss.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Bring him out of the palace!” I ordered, and two of the tallest, strongest Summer Knights entered the palace. Not five minutes later they returned again, with the toad-like Wort.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They dropped him unceremoniously at my feet.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Your Highness,” he said, trying his hardest to win me over with an exaggerated bow and an obsequious smile. “What is the meaning of all of this? I was merely smoothing things over while you were away.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“While you were poisoning me with kelpie soup, you mean!” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A gasp was heard in the crowds. “Kelpie soup? It is forbidden.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I turned towards the voice. “Why is that?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A young woman with reddish-brown hair the color of Rodney’s stepped out of the crowd. She was dressed in a white dress with gold embroidery. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rodney smiled and rushed over to hug the girl. He came forward with his right arm held tightly around the girl’s shoulders. “Your Highness,” he said. “This is my little sister, Rose.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rose, who had Rodney’s bright blue eyes, fair skin, and high cheekbones, looked shyly at me before she curtsied. Despite her shyness, she seemed to be close to my age. “Your Highness,” she said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I nodded. Why haven’t I seen her before, if she was Rodney’s sister?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Rose,” I said. “You said something about Kelpie soup being forbidden. Why? What is it?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rose blushed, realizing all eyes were on her. “I’ve been studying...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rodney spoke up proudly. “My sister has been apprenticing as an alchemist. She’s in her final year.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rose nodded and went on. “Kelpie soup, Your Highness, is used to bring about hallucinations. Yes, it does have its healing, soothing powers, but the side effects are worse.” She hesitated, not sure if she should be saying this in front of everyone. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I waited for Rose to go on before I realized she was looking everywhere else, her eyes darting around, afraid to look me in the eyes. I leaned forward so I can talk to her directly. “What is it?” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She looked at me and looked embarrassed. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You can whisper what you’re going to say in my ear,” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rose finally looked relieved. “Kelpie soup is known to cause infertility...if ingested often. Because of its delicacy, the royal fairies used to be the only ones able to have Kelpie soup, but as time went along and the Royals began having problems conceiving, it was discovered Kelpie soup had this effect on fairies. Hundreds of years ago, it was forbidden.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I reeled back. No wonder why Redleaf was not able to have a child. No wonder why the royals were dying out. “Thank you for telling me,” I said before fastening my angry eyes at Wort.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Wort gave out a slimy laugh. “About that...” he wheezed. “It's all a misunderstanding! I guarantee it!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Indeed,” I said. Wort clearly wasn't convincing anyone. “Now, traitor, I will spare your life – but instead I am forced to banish you, far from the fairy territories you have invaded!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Wort's face turned red with anger. “Banish "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("me?")]), _vm._v("” he shouted! “Banish "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("me")]), _vm._v("!” He looked as if his head were on the verge of exploding. “It's my city! My court! Mine!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It belongs,” I said, in my most regal voice, “to the Crown of the Summer Court. A crown I now demand that you return to me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In an instant, the crown swooped off his head and alighted on mine, emitting a bright, golden glow as it did so.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Am I not your rightful ruler?” I shouted to the crowd. “Am I not your Queen?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The sound of the crowd's cheer drove the point home; it was clear from Wort's bulging eyes that he knew, at last, that he had been trapped.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“As you wish, Your Highness,” he spat. Then, suddenly, with a sickening "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pop ")]), _vm._v("that reminded me of road-kill, he vanished.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What the...” Rodney said, looking around wildly. “That's not fairy magic. That's Pixie...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But he was cut off. Another loud "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pop ")]), _vm._v("echoed in our ears, and suddenly my horse reared up in terror, letting loose a high-pitched whinny filled with fear. Before I could work out what was going on, my horse had thrown me, and I fell onto the cold, hard marble of the palace steps. I was lucky I did not break my neck!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Bree, watch out!” Logan cried.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A snake was slithering towards me on the ground –baring its piercing fangs and flickering its tongue at me. Its eyes were yellow, cruel, but I recognized within them a familiar toadish glow...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Before I could reach for my sword, the snake struck, wrapping its body around me with lightning speed. The guards rushed towards me, but it was too late. The snake had wrapped its entire body around me, crushing my ribs as it reared its savage head at the guards.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I spluttered, trying to think fast, to reach my sword, as the Wort-snake's fangs reared up, coming closer and closer to my neck.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Power of the sun, protect me, ")]), _vm._v("I thought, as the last breath of air was pushed out of me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Suddenly my whole body began to glow, shimmering gold with the power of summer heat and fire. I focused on what I had learned to think of as my strength – my love for my people, my birthright as Summer Queen, my love for Kian.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("At last, the snake's muscles relaxed, and it fell loose from my body – slack and limp as spaghetti.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Get him!” I cried, still coughing.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The guards rushed forward, piercing the snake's tail with their swords.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ow!” with a howl, the snake began to morph, transforming in a sickening shimmer into Wort once more, blood running through his foot.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Red blood.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“A Pixie in disguise!” cried Rodney. “I knew no fairy could be so ugly!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You won't escape this time,” muttered another soldier, as they rushed to bind Wort in chains.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The commotion gave me time to catch my breath. I had always known Wort to be slimy and untrustworthy – but a Pixie – able to glamor as only Pixies could? I shuddered. How close had I been to true danger this whole time...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Wort stood proudly. “I am a royal Pixie, half-brother to Delano. I am only trying to take back what was ours.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Delano’s half-brother? So now Pixies were glamoured as fairies in Court? Wort had come to the Summer Court from Autumn, and now they were part of Summer. I looked around. How many Pixies were glamoured as fairies in my court?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Put him in the cell,” I said, regaining my composure. “And don't let him out of your sight!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The crowds began to cheer once more.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I hereby declare that I have appointed a new adviser,” I said, trying to continue as if nothing had happened. “One who is loyal and true – and will serve the interests of the Summer Court always.” I held out my hand. “The Wolf, Logan, whose service to this land is unrivaled.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan looked shocked, but his expression of astonishment gave way quickly to surprise. “Gosh,” he said, blushing from the tip of his ears, “Thanks, Bree.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We're friends, right?” Kian or no Kian, I couldn't let my friendship with Logan go.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan bowed deep.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Furthermore,” I said, “I wish to elevate the rank of the brave knight Rodney, who has done so much for peace. You are now Sir Rodney, Duke of the Spring Pass!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rodney flushed and grinned too, although through his joy I could see the echoes of his pain All the dukedoms in the world could not make up for the loss of Shasta. I understood his feelings all too well. But there was no time for that.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“From now on,” I shouted, “the Summer Court will be a place of beauty – and of harmony – and of peace.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I felt the crown – heavy and still glimmering – set upon my head. Nothing had ever felt so right in the world.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("These were my people. This was my place, now. This was my home.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 17")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-w"
  }, [_vm._v("W")])])]), _vm._v("e decided to celebrate our victory with a feast. The crowds in the streets had been cheering until the sun of Summer had set, and the streets were filled with dancers and singers, fairies rejoicing at the end of the war at last. They had been baying for the blood of the Winter Court not a few weeks ago – but my having returned with the Spring Pass to call our own had changed all that. As far as anyone in the Summer Court was concerned, the Summer fairies had won the war!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You must hold a celebratory ball, Your Highness!” said Micah, one of Rodney's seconds-in-command. “You don't know how long your people have waited for a celebration like this one!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Generations,” agreed Rodney.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And so it was decided. Although my days of travel had left me feeling much more in the mood for a long bath and many hours of sleep than for an evening of dancing, it was decided that the Victory Ball would be held in the palace that very evening, and that all the fairies of the Summer Court were to be invited. How could I deny my people this celebration? As I recalled from the days before I knew I was a fairy royal, when I was researching mythology with Logan in the high school library, fairies loved celebrations...they loved music, art, and especially dancing. Celebrations were part of my people’s heritage. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It was strange walking around the Summer Palace as if, at last, I had come to own the place. The last few times I had visited, I had visited as somebody's prisoner: either as the literal prisoner of Redleaf, or as the virtual prisoner of Wort, who had seized my power with a bowl of kelpie soup. How insane. If Logan and I were back in Gregory, we would be laughing about the insanity of kelpie soup. My human side would laugh at how everything that happened to me in Feyland had actually happened. But it did, and it was real, as real as I was walking through the palace I had always dreamed about every night since I was a little girl. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I would be eating far tastier victuals than soup tonight, I promised myself, looking around at all the rooms that I could at last safely call my own. There was a ballroom shining with what looked like thousands of kinds of diamonds, hanging down in sparkling chains from the ceiling. There was a library filled with so many books that it would have taken my whole army of fairies a lifetime to read them all. There was a throne room and an antechamber and several banquet halls, each with tapestries depicting the rich history of Feyland in vibrant fairy silk and wool. And then there were my rooms – the private bedchamber of the Queen that Wort had taken to using since Redleaf's death, the study, the bathroom – with the largest, most delicious-looking marble bath I had ever seen – and the wardrobe.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("As I opened the doors of the wardrobe, a flurry of fabric rushed past me. Red, blue, silver, and gold all appeared and then vanished before my eyes as a new option jostled to take its place. I lingered there a while, letting my fingers feel the smooth silk and the warm velvet, before deciding on an appropriately ceremonial gown of golden satin with a pink and orange trim – the colors of sunrise. It would represent a new beginning for the Summer Court, I decided; this would be the dawn of a golden age for our kingdom.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It had better be worth it, I thought as I put on the dress, feeling it magically fit to the contours of my body – more muscular and toned now from several weeks' riding. It had better be worth losing...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I couldn't even bear to think his name. I closed my eyes and smoothed down the folds of my dress. It was time to focus on the Ball at hand.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It was decided that Logan was to be my escort. When I appeared at the top of the stairs leading down to the Great Hall, I could see his sharp intake of breath, his slight blush.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You look beautiful, Princess,” he said, bowing deeply.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He looked more handsome than I had ever seen him. At last finished with the work and turmoil that had characterized the last few days, he had shaved and trimmed his hair, his rugged charm smoothed out into something almost like elegance. He was not wearing the customary golden robes of the Summer Court, but rather a pelt of fur over his shoulders, the mark of a Wolf. In other times, werewolves might have been shunned in such a place of court, but he wore his tribal garb proudly.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It is the pelt of a rival clan,” he said. “This wolf killed my grandfather, and my father avenged him. I wear it now.” Logan smiled. “I hope you don’t mind, but since your announcement, word has spread all over Feyland. There will be some of my clan here, wishing to pay tribute for this victory. And wanting to see the new Summer Queen and her adviser.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Logan,” I said, playfully touching his shoulder with my hand. “How can I mind? You’re part of the reason for this victory. I want to share this with you, for your loyalty, for your bravery, for always being there for me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Is that why you made me your adviser,” Logan asked, his eyes hooded. “So I can always be there for you?” He paused. “You don’t have to make me the Adviser for that. I will always stick by you title or no title.” His eyes shone like stars as they expressed his joy at finally being accepted, finally finding a place by my side in Feyland.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He seemed more confident than ever, his animal prowess still clear even in his human form.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Shall we dance?” Logan bowed deeply, and I couldn't help but curtsey as I allowed him to place his warm, strong hands around my frame and whisk me away across the floor. The music struck up a bright dance – not the fairy waltz, for I had made it clear that such a song would not be played tonight – but a lively folk dance that my feet seemed to know how to follow on their own.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We danced for what seemed like hours, and when at last the great gong was struck and the banquet announced, we were all relieved to lighten our feet and load up our stomachs.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("While servers came by with golden plates filled with roasted fairy vegetables, steaming pots of root soup, fresh warm bread, and colorful fruits from all over the Summer Kingdom; Logan pointed out the various members of the Wolf Fey, gathered in the ballroom, seated for the meal. They were in human form...men wearing the same tribal attire as Logan with a wolf pelt on the shoulder. Like Logan, they were tall, handsome, and tanned. “The Wolf Fey,” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” Logan said proudly. “I should’ve told you, Breena, but we’re not ordinary werewolves. Because we’re from Feyland, we’re touched by fey magic.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Are you fairies, then?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Originally, yes,” Logan said. “The original wolves were fairies who could transform into wolves. Having been going back and forth through the Land Beyond the Crystal River for generations upon generations, the Wolf Fey met and married too many humans to now have more human blood in them than fairy.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No wonder you and I have always felt this connection,” I said. “You have fairy blood and human blood, as I do.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan nodded. “Of course I didn’t know that about you when we were five. I just knew you were the prettiest little girl I’ve ever seen and the nicest one. I just know that whenever we were together, it made me happy.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I smiled at Logan, feeling closer than ever. His devotion warmed me. I was lucky to have him as a friend. Luckier still to have his love.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I caught a glimpse of Rodney glancing outside the ballroom out the window into the dark starry night. I could only guess what he was thinking of, and whom he was thinking of – Shasta. Since they were lovers, could they be communicating right now with their minds, sharing talks of impassioned love? Kian had said this was possible between lovers as long as the love was there, and it was returned. I couldn’t think of him now...it was too painful.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rodney saw me looking at him and immediately smiled back. Despite his love for Shasta, he was a loyal Summer denizen. At least his family was here. I smiled as I saw Rose come up to him with a plate of food. An alchemist-in-training, a girl of my age. I was intrigued. From what Rose told me about Kelpie soup, the Summer Court would do well to have an alchemist in Court. Rose glanced over at me and smiled, and then she blushed as she glanced quickly to my side.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan sat at my side as server-fairies appeared, bowing as they poured us jug after jug of wine and brought out course after course, until our tables were laden with plates. Looking like the Wolf Prince, he had never looked more handsome, glowing with confidence and happiness.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“More wine, Your Highness?” asked one maid, with a familiar face. I laughed as I nodded her to go ahead, and she filled my goblet and Logan's before traipsing off.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We drank deeply. This was a different fairy wine to the one we had been drinking earlier – it was darker, stronger, with the harsh bittersweet taste of chocolate and thorny blackberries.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“More, please!” Logan said, downing the last of his goblet. “Let's get that maid back – where is she?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I furrowed my brow looking for her, but I couldn't find her anywhere in the crowd.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Suddenly her face appeared to me again in my mind's eye. I had seen her before – but where? A memory flitted across my brain – a room, a chamber, Wort's leering grin, a bowl of kelpie soup...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Where had she gone?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I rose, but there was no sign of her. Suddenly, the room began to spin, and I felt my body begin to tremble and shake. I felt flushed.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Are you okay?” Logan caught me, wrapping me in his arms.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("When I turned to face him, it was as if I was seeing him for the first time. His eyes were darker, more piercing, filled with the animalistic longing I had for so long sensed in him. His cheekbones were sharp; his jaw was passionate. He was so handsome, so masculine. I had always thought he was gorgeous, but now he was brimming with sensuality rippling through his muscles, the way he smelled so intoxicatingly of musk.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'm fine,” I answered. Yet as we sat I could feel that Logan kept his arms around me, and I found that my hand, too, was resting upon his knee. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I stopped. There was something I had been worried about a moment earlier – something about a maid, a face I had seen before, something that had worried me...but I had forgotten it now. The room was still spinning, but all that mattered was the beating of my heart, faster and faster now, and the beating of Logan's heart – echoing in my ears, and the electric touch that connected us.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Logan?” I whispered. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Breena!” He looked at me, his eyes more full of longing and desire than I had ever seen them. How had I ignored them for so long? How could any girl resist his powerful might, his charms? ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I wanted him. My heart thundered within me and my breath grew shallow; I could feel his hands linger upon my knee, brushing lightly higher upon my thigh.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The music was still playing loudly; diners were beginning to get up and dance, taking part in a second round of revelry, but all I could hear was the twinned sound of our two heartbeats, our two desires.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Wasn't there something I was forgetting? A memory – as far away as an echo of a dream – leaped out at me: a vision of a boy with blue eyes and black hair, a prince with shimmering armor and a promise of eternal love. But such a vision seemed to be little more than smoke from a long-gone fire, a ghostly gossamer that appeared and then vanished before my mind could properly adjust. No, there was nothing else, nothing that mattered except the pulsing, pounding force within me, my desire for Logan – my love.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Do you want to get out of here?” Logan murmured, his voice making the hairs on my neck stand on edge.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We rose quickly and stumbled through the throng – the bright dancers, the grinning drummers, the raising after raising of goblets of wine – our hands intertwined as we raced through the palace, in search of somewhere we could be alone, somewhere we could give in...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Here!” I whispered, as we reached my bedchamber. In haste we unlocked the door; in even faster haste we locked it again. No sooner had the key turned in the bolt than Logan was kissing me, letting his desire spread through me, consuming me, overpowering me. And I wanted him too, my desire for him so strong that I felt it must have existed always – a desire that tasted strongly of chocolate, and thorny blackberries, and wine.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I love you, Breena,” Logan murmured. “I've always loved you. I've wanted you for so long, so much.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I love you too,” I was saying, swooning into him, spinning down onto the bed with the room spinning all around me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And then Logan was on the bed too, beside me, his body warm and pulsing beside me, his heat overpowering me, his mouth fused to mine.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And as we kissed, and he slipped the satin from my shoulders, I felt within me a cry of pain, a telepathic stab of agony that coursed through me and made me shudder – an image of a prince in a silver castle, tearing at his hair, crying out to the cold and unlistening wind.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But I did not know him. I did not remember him. A distant memory. And so I put the image out of my mind, and closed my eyes, and let the magic of the night overtake me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 18")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-t"
  }, [_vm._v("T")])])]), _vm._v("hat night I slept soundly, but in my sleep there was a dream – a fitful dream of men and women I did not know, or could only just remember, and when I woke up I woke up screaming and gasping for breath, and even Logan could not comfort me. That night, and for many nights after that, I dreamed again and again of that strange boy who flitted across my thoughts. As time passed I remembered who he was – he was Prince Kian, and we had known each other once, or had we? He and I had worked together to broker peace. Had we been involved? I couldn't remember – or perhaps we had been, but somehow whenever my mind tried to reach him, to remember what it was about Prince Kian that gave me these nightmares, the thoughts would vanish, the way shadows vanish at the very presence of light. I tried to talk to Logan about these dreams, these strange thoughts – these memories that seemed so important and yet so gossamer, so constantly out of my reach – but it was no use. He had no more memory than I did of these strange events. In any case, I had much to think about, and the upcoming Peace Treaty Summit with the Crown Prince, his mother the Snow Queen of the Winter Court more than preoccupied my thoughts.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Wort was now in the Summer Prison with the rest of the dissenters, whom Logan and I had weeded out, awaiting his trial and final magical banishment from Feyland altogether. Logan and Rodney had together begun training the army for new strategies – abandoning war in favor of a stronger defense strategy and more attention paid to the Pixie lands. If Wort and Delano were anything to go by, the Pixies were our greatest enemies now.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And yet, for all the joy that the Peace Treaty brought to me and my Court, my greatest happiness was the time I spent with Logan. We were in the Summer Gardens, the one with an intricate maze built of summer rose bushes of every shade, walking hand in hand when he turned to me under the white blossoms of the fragrant orange trees, got on one knee, and presented me with a ring forged from gold and diamonds. In the center were diamonds cut into small clusters that formed a crescent moon...the symbol of the Wolf Fey. For wolves from Feyland were touched by fey magic.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Breena,” Logan said. “I’ve loved you for all my life. I’ve never loved anyone or anything more than I love you. We have been together for so long, and I know you as well as I know myself. You are part of me, and I am part of you. Without you, I would not be complete.” Logan’s lips quivered with emotion. “Please say you will marry me, Breena.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My hands trembled as Logan placed the ring on my finger, and I stared into his big dark eyes, filled with longing and love. I could not think of anyone I loved more. There had always been Logan, only him. “Yes,” I said, reaching up to kiss him. “I love you so much!” His eyes shone with such love and happiness as his face bent down to kiss me. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We had announced our relationship to the Court publicly within a few days, announcing a Royal Engagement that sent the people of Feyland into a state of shock and scandal. No Fairy Queen had ever married a Werewolf before – and yet so overjoyed were the fairies by their latest victory against the Winter Court that I could have married a Pixie himself and been able to get away with it. It is a new age – the fairies cried. There is peace now! Things are different!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("After all, Logan had gained a place of great distinction in the Summer Court. It was his bravery in defending me from both the Pixie Delano and the knights of the Winter Court that had allowed peace to occur, and he had been presiding with me at the Spring Pass when the lands were at last returned to the Summer realm. His natural charisma and charm, too, had served him well, and before long it seemed that all the fairies in the land were overjoyed to have Logan as their future Prince Regent. He would be my Wolf Prince.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I spent my days attending to queenly duties – signing treaties, holding audiences, receiving my ministers – but the best parts of all were when Logan appeared between each break in my schedule, taking me in his arms, nuzzling my ears and throat, warming me with his kiss with every spare moment of his day. We could not take our eyes off each other whenever we were in the same room. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And yet, when I slept, I dreamed the most terrible dreams. I dreamed of the Crown Prince Kian, rage and fire in his eyes, reacting to some terrible and unspeakable news. I saw in my mind's eye the Prince throwing his crown against the room, striding up to a pageboy and picking him up by the collar, demanding to know the truth, the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("real ")]), _vm._v("truth.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You're lying!” he was shouting. “You're lying! It can't be true!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It is, Your Highness,” stuttered the page-boy. “The Princess Breena is engaged to be married to the Wolf Logan! I saw it with my own eyes!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A hazy sense of recollection seemed to come back to me in my dreams. I was the cause of this, wasn't I? There was something I had done...had Kian been in love with me once? Or perhaps we had been involved – how strange that I could barely remember what it was...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I saw the Winter Queen placing a calm hand on Kian's shoulder, speaking in an implacable tone about the nature of duty, about the importance of suppressing emotions. I saw the Princess Shasta, in a corner, clapping her hand over her mouth as she shouted obscenities, her anger almost matching that of her brother. How could Breena betray her brother like this? ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In my dreams, time passed. I saw Kian night after night – growing darker and colder, locking himself in his tower room, speaking to nobody but Shasta. He would not eat; he would not sleep. I saw the shadow-boy of my dreams grow thinner and paler, staring out across the moors at the Summer Palace. I saw him leave the Winter Grounds at all hours of the morning and return with scores of Pixie prisoners, or dragon scales – taking on the most dangerous missions he could find, speaking to no-one, shutting out the pain. I saw him fight Pixies unarmed, as if willing them to kill him, daring them to end his life, his pain, his suffering. In my dreams I suffered with him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And yet, each morning, I woke up to find my memory of the Prince Kian hazier than ever. I could vaguely recollect that we had been involved, somehow, but I could not call to mind a single instance where we had ever talked, ever kissed.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I wouldn't worry about it,” said Logan, patting my hand. “You're probably just stressed.” Logan did not know where or when had I met the Winter Prince. He could only recall me dreaming of the enemy prince and having once been his intended when I was but a toddler.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And so, night by night, I forgot my dreams.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 19")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")])])]), _vm._v("t was time for us to start anew, to celebrate a new era of peace and prosperity. It was time for the Peace Summit. We had spent hours preparing for the arrival of the Prince Kian and the Princess Shasta, who had been sent to sign the treaty, alongside their mother – the first time the Winter Queen had set foot on Summer Territory in decades. There had been trees and flowers planted in the front palace – lily-blossoms alongside orange-trees, silver tapestries alongside golden ones – the two suns of Feyland rendered in gorgeous gems and candles hanging from the ceiling of the Great Hall. This was to be the most important day in the lifetimes of many of my people, I knew; I had to give it all my energy. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Yet my mind was not untroubled. My dreams had grown worse and worse, and although by day I had convinced myself that everything was fine – that I loved Logan, that our passion had been predetermined – something seemed wrong. The thought of the Crown Prince Kian coming to sign the treaty made me feel physically, viscerally ill; the mention of his name in a Court meeting was enough to make me tremble inwardly.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But why? He was my enemy – we had been intended as children; for at last I had concluded that this was the reason behind my dreams – and nothing more. He had kidnapped me away from the Land Beyond the Crystal River and somehow – I couldn't quite remember how – I had escaped, ready to take on my role of leadership in Feyland. I had been destined to defeat him; I was perfectly happy to sign the peace treaty – but there was nothing more than that, nothing at all.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You're more beautiful than ever,” Logan told me, kissing me as we dressed for the occasion. “Your power has made you radiant – you're alive with the beauty of Summer.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I looked in the mirror and blushed. Where I had once seen a skinny, gangly sixteen-year-old girl, I now saw a mature and ready woman – beautiful, if I was beautiful at all, in my confidence, my poise, my grace. I was a ruler, now, and this ruling magic was reflected in the shape of my face, the curve of my shoulders.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Every day,” said Logan, kissing my eyelids, “I count down to our wedding night.” He held me closer, tighter. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Memories of our childhood together flooded through me – the way Logan had always taken care of me, the way he had always ensured that I was safe. The way he had cooked for me back in Gregory, Oregon, piling the supplies high on the counter and bidding me choose what I wanted. The way he had kept me safe from bullies like Clariss at school, taking care of me, preserving me, loving me. I was so lucky to have him in my life.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan placed my crown upon my hair, stroking my hair as he did so. “You were always a Queen for me,” he said, gathering me into his arms, and kissing my forehead.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We entered the Grand Hall together. Rodney came running up to us! “They're here!” he said. “The Winter Court has arrived!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The sound of trumpets called us to the windows. There, we saw the Winter Court making its way through the streets – a small but significant number of knights and ladies, Dukes and duchesses – all unarmed, of course, tall, graceful, and beautiful with the ice cold beauty of winter frost – proceeding through to the very gates of the palace. Not three weeks earlier, this sight would have produced panic among the citizens of Feyland. But now they were greeted with flags bearing the emblem of peace – if not with the same joy with which I was greeted when I arrived. Among them I saw the Winter Queen, cold but beautiful, with her dark hair and swan-like neck. Beside her in the carriage was sitting the Princess Shasta, with her proud gaze and dark smile.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And then my heart stood still. I saw him – the Prince  Kian – sitting beside them. He was not how I remembered him from my dreams. This looked like no Prince to me. Darkly handsome, he was unshaven; his hair was long and wild – he looked like a wolf; his eyes stared out into the distance, so full of darkness that they seemed to encompass all the pain, all the anger, all the suffering in the world. I felt my breath constrict within my breast; I sighed and bit my lip, as the familiar sense of pain rose up within me – the sense that something was wrong. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("But what?")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We received the Winter Court in the Great Hall. Logan stood at my side – a warm presence, as close and protecting as a fireside in the snow. One by one, I shook hands with the denizens of the Winter Court: the Winter Queen, Shasta, and then...Kian.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("When we touched our hands together, it was as if all the light in the world had gone out, its energy sucked into our touch. He stared at me with eyes aflame with anger, his pupils dilated with darkness, a rage that seemed to suck my soul out of itself and destroy it whole.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Your Highness,” he said, through gritted teeth. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Again I felt the same, sharp, familiar pain, but I ignored it. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I am glad we can discuss peace at last, my Prince.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian gave a hollow laugh. “"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Your ")]), _vm._v("Prince indeed,” he said, his voice scathing. “And how many other princes do you consider yours?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan took a step forward, placing his hand around my waist.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I see...” said Kian. “It is not my place – we are, after all, on your home turf.” He bowed deeply and stalked off, leaving the Winter Queen and Shasta to glare at me even as we stood, trying desperately to make small talk.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I couldn't help it; my eyes followed Kian across the room – a fact I tried my best to hide from Logan. I knew I loved Logan, yet this mysterious prince – with his dark eyes, his mysterious gaze, this anger and passion that seemed to spring from nowhere – had caught my attention. Why had I dreamed about him so often, and yet why couldn't I remember why? I felt my heart begin to struggle, as if it had been caught in a trap, caged, and yet saw its own escape somewhere. A cry rose up deep within my soul – a cry that seemed to say "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Stop! ")]), _vm._v("even as I did my best to ignore its call.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("What was happening? Was I going crazy? I shook my head and decided to attend to the other guests. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("After a time I grew weary, and the guests began to disperse to their separate chambers. I began to return to my room, eager to change into the ball gown Logan had picked out for the Peace Banquet tonight, at which the treaty would be signed. I slipped into a corridor – alone at last, and relieved to be taking at least a short break from my queenly duties.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Before I could reach my bedchamber, a hand clapped over my mouth.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What the...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He grabbed my wrist and spun me to face him, his eyes sparkling and alive. “What is the meaning of this?” his voice was soft, but filled with enough power, enough rage, to bring down the wall of the castle. It was the Prince.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What is the meaning of "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this")]), _vm._v("?” I responded in outrage! How dare the Winter Prince touch me in such a way. “Unhand me, Your Highness, at once!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Your Highness?” Kian's laugh was full of bitterness. “Is that all?” he scoffed. “Have you forgotten your promise to me already, Breena? So soon?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I have kept my promise,” I said, wrenching my wrists away from his grasp. “I have brought you and your family here to sign the peace treaty, as requested. What more do you want? We are on our way to peace.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian turned paler than before, throwing up his hands between rage and astonishment. “Yes, that was why we came here. Do you remember what you promised? One day, Breena – when there was peace in the kingdom – we would be together? Or was that a lie to get me to help you sign over the Spring lands to Summer?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What are you talking about?” The Prince was mad – I could have laughed! “Be with you? We haven't been intended for each other for sixteen years, Your Highness!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sixteen years? What the hell are you talking about, Breena!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'm engaged, Your Highness! As you well know – and I'd advise you not to be making such ridiculous statements within earshot of my fiance.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian stopped and stared. “Have you gone mad?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mad, what are you talking about – mad? I'm not the one talking nonsense. All I've done is remain here, in the Summer Court, happy with my love...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You can't be happy, Breena,” Kian's voice grew soft, urgent, caressing. “Not with him – not with him. Tell me you're not happy with him...” He sighed. “Tell me you don't love me. To my face. Tell me you don't love me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Fine,” I said. “If it will get you to leave me alone. I don't...” But as I caught sight of his panicked, stricken expression, my voice failed me; my body refused me. My tongue froze and stood limp within my mouth.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Breena!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And then he was upon me, kissing me, his mouth hot upon mine and devouring me whole, and the force of his passion shuddered through me, and with it there came memories – fragments that somehow made up a whole...a fairy waltz, a hunting lodge, a kiss so electric my very soul shook to the core, a kiss that we had kissed, that grim evening in the snow orchard in the Winter Palace, where we said goodbye, our tears mingling together...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I pulled away, overcome. My eyes were glistening with tears, but I could not even remember having started to cry.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I don't...I don't understand...” I said, putting out a hand to steady myself.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian caught me, his arms so familiar as they wrapped around mine.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Breena, what's happened to you?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I don't know...” I was shaking. “I don't remember you...or maybe I do...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But my body remembered. My mind went blank as I found myself reaching for Kian again, kissing him back, pressing my lips against him, my tears wet and warm upon his icy marble cheeks, found myself leading him into my bedchamber – still kissing him the whole while.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kian?” At last it all started to make sense – or some of it. “What's going on...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Have you been drugged?” Kian sat next to me. “Or a spell – has someone put a spell...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I stared out into the distance. “I don't know! All I know is I didn't remember – didn't remember anything – but now all these memories...” I started hyperventilating, shivering so hard my teeth were chattering against each other. “I'm just so confused.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kian took my hand. “Do you remember me?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You're the Crown Prince!” I responded. “No – but...in the hunting lodge – we kissed...we were engaged...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes! I showed you my fairy paintings on the wall!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But...that was a dream, wasn't it?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, Breena,” he kissed my hands, overcome with relief. “It was real. It was real – I knew you couldn't have forgotten me, not truly! Someone's put a spell on you – it's the only answer!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I missed you...” I heard myself saying, and I knew that it was true.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I missed you so much. When I heard the news, I thought I'd lost your love forever. I wanted to die. I went mad with misery, with rage. I was confused, so confused – I thought you'd betrayed me, been playing me the whole time to get peace...I volunteered for the most dangerous missions, hoping that a giant or a dragon would end my suffering!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I'm so sorry!” I started to cry harder now, great tears plummeting down my cheeks. “I didn't know. I don't know what happened. It was as though I forgot all about you, about our love. I saw you only as the enemy, the Winter Queen's son, the Prince. That was it! I had these dreams about you – and I thought it was only because you were my enemy, that I felt this pain whenever I heard your name.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I would never hurt you!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I would never hurt you!” I responded, wiping the tears from my eyes. It's just...whatever happened to me – it was like I didn't know you at all!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, Breena!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But before he could finish, I was on top of him, kissing him, burying my love in his face, his neck, his shoulders, trying to understand what had happened to me, make sense of it, or else push it out of my mind. There was only Kian, my love Kian, and everything else was forgotten...Kian closed his eyes, inhaling the scent of my perfume. “I want this too much,” he said. “I want you so much, Breena!” he rolled on top of me giving in to the desire I saw in his eyes. “I want us to rule together, to bring our kingdoms together. There can be no peace without you by my side. I can't deny it to the Winter Court any longer!” He began with kissing my forehead, moving down to my eyelids, my lips, my chin, the contours of my breasts. I felt him fumble with my dress, and then a cloud of satin fell to the floor.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A familiar feeling. I had done this before – three weeks earlier – with Logan. Logan! His face came into my mind, and against myself I felt the same passionate longing for him I had been feeling since then. I had felt it – and it had turned out to be a lie, or a spell...and yet I had felt it all the same! How could I trust my feelings, my sensations, my desires, when they had been so easily manipulated?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Stop...” I whispered. I suddenly felt afraid – betrayed– not by Kian but by my own body. How could my senses lie to me in that way, take me prisoner? I felt sick, overwhelmed.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What's wrong?” Kian furrowed his brow.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Not when I'm so confused...I don't even know what happened.” I started pulling my dress back on. “I don't know what's real or what's fake anymore....”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It was a spell!” Kian cried! “It must have been! What else would affect your memory like that? I've heard tell of spells – ancient secrets forbidden by the Fey. They destroy your mind, make you believe you're in love with someone else.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Whatever it was,” I said, “It's not broken. Or...it is...but it's not. I still remember everything that happened when I was under it; I still remember how I felt, how...and oh God, Logan must be still under the spell, too!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I stood up. “He doesn't realize...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Who could have done this to you, Breena?” Kian pulled me back down. “Who wants you to forget me?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wort!” we said together. Only he could want so badly for the Winter Court and the Summer Court to be at war again. From the first time I had met Wort, he had poisoned me with kelpie soup, giving me dreams of Kian as my enemy, destined to stab me with his silver sword, to kill me...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Where is he now?” Kian asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“In prison – to be banished. We're sending him away tonight.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The faster he's out of your court, the better,” said Kian. “Who knows what else his supporters have been up to while you've been under this spell? If it affected your judgment, what else could it have done?” He sighed and grew serious. “Breena,” he murmured. “Losing you – I think that it made me realize just how much I loved you. When I thought I'd lost you, life was over for me. It meant nothing. I thought perhaps duty was right, but now I know better. Denying my own heart is too terrible a thing to agree to do. There can be no peace without the two of us together, united, supporting each other. I never want to give you up again. Even if I have to give up my kingdom to do it – let Shasta be Queen and become your faithful Summer civilian.” He looked vulnerable, even with all his sword and armor – a heart I could break or restore with a single word. He pulled from his pocket a crystal snowflake, shining blue and silver, alive with ethereal energy.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My eyes were drawn to it instantly. “What is this?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It's the source of immortality,” said Kian. “The rarest of all the Winter Fairies' gems. Its power lies in its ability to grant its bearer the immortality – to live forever. Each snowflake, like each person, is unique: there is only one of these in the world.” He held it up. “I want you to have it. To become immortal – as my wife.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Is this the source of your immortality?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No – we fairy princes have it already. We too will live forever – provided we are not killed in battle. The immortality in this crystal is magical in a different way. It means nothing can harm you. It keeps me safe – but it would keep you alive forever.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Alive forever? The idea was overwhelming to me. Moments before, I had been in love with Logan – and although I knew now it was a spell – it didn't feel any less real to me. I still loved Logan, his eyes, his warmth. And as much as I loved Kian, making the choice to be with him forever – "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("forever –")]), _vm._v(" felt overwhelming.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Do you choose me, Breena?” he was asking. “Do you choose me as I have chosen you?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I wanted to say yes – I wanted to run into his arms and accept. But something – the memory of Logan's face, my own fear, the sense of confusion still strong within my body – kept me from saying yes. I could only stare at Kian silently, tears running down my cheeks.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I see,” he said quietly. He threw the crystal snowflake on the bed, his face hot with anger. “I thought the crystal would protect me from all things,” he said. “Apparently not this.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Before I could protest, he had left the room.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 20")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")])])]), _vm._v(" followed Kian into the corridor, hoping to catch him, but was too late. By the time I caught up with him, we were in the Great Hall once more, and the Banquet was in full swing. Fairies in silver and gold robes chatted together, danced together, ate together, and I had lost Kian in the crowd. Immediately I was mobbed by hundreds of Court fairies wishing to talk to me, gossip with me, or curry my favor. The signing was to occur at midnight, in only a few moment's time. I would have to talk to Kian later on; it was time to focus.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Suddenly, I spotted one of the fairy knights I knew from Logan's retinue, a guard called Whiteflame. He strode up to me and tapped me on the shoulder.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“May I speak to you a moment?” he whispered. Urgency shook his voice.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Of course!” I gave a polite smile to the Duchess of Ice City and allowed Whiteflame to lead me to the side of the room.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We have an emergency,” Whiteflame growled. “Wort has escaped. There was a rebel group of some Summer knights who broke him out – they killed all the guards. I was the only one to escape.” He was out of breath. “I think they plan to siege the castle – tonight!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I gasped. It was obvious what Wort was planning. A siege on Winter and Summer together – at their most vulnerable – would shatter any hopes for peace. His spell had affected my judgment – as Kian had said – I'd been so distracted by my enchanted feelings for Logan I hadn't even worried that Wort might have more supporters in the Court.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Get all the security in here you can!” I said, as an array of loyal Summer knights began to circle around me, ready for actions. “The guests will have to fight.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("What could I say to them? If I told the Winter Court we had an uprising, that I'd lost control of my own kingdom, nobody would believe me – they'd think it was a set-up, a chance to slaughter all of their number in one place. We couldn't have played into Wort's plans any better than if he'd planned it – or had he?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We heard the sounds of commotion from outside the Great Hall – the footsteps of knights, the clanking of chain mail. “Bolt the door!” I cried, and two Summer knights rushed to do my bidding.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What's going on?” Logan came up behind me, kissing my shoulder. I whirled around to face him. My passion for him was gone – but I could not forget the nights we'd spent together; it was clear from his expression that his love for me was unchanged. How could I hurt him, tell him it was only a spell? I loved him still, but not with the blinding crazy love I had for him for the last three weeks.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I took Logan's hand, and out of the corner of my eye I saw Kian glowering at us, rage and jealousy on his face. “There's a situation,” I whispered. “Wort's escaped – he and his men plan to besiege the castle – "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("now")]), _vm._v("! Slaughter the Winter fairies – perhaps us, too!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Suddenly, Rodney rushed to my side, breathless. “They've killed all the guards!” he said. “We need to get ready to fight – "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("now")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I needed to find Kian. He loved me – he would trust me! He'd asked me to marry him moments before; he, of everyone, would believe it wasn't a set-up, would know what to do.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I dashed across the hall to where Kian stood against a pillar, staring at me, waiting for me, a look I’ve never seen in his eyes. Wicked anger and hate even. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I turned to Kian, willing him to listen, trying to open our old channels of telepathy. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Kian – there's a problem – Wort's escaped – he's coming with his guards to fight us – I need your help! Please! ")]), _vm._v("I sent all my love, my pain, my fear into the message, willing him to understand, to believe me. But his face remained un-moved, stone still. He stared at me only with blank, cold anger: no trace of love. Where was my Prince?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 21")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-s"
  }, [_vm._v("S")])])]), _vm._v("uddenly, the doors burst open, and we were swarmed by what must have been fifty soldiers.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh no,” Rodney said, and in a moment I too realized why he was panicking. The soldiers were dressed just like Summer Knights, in the traditional yellow robes of court. There was no way of telling which were loyal Summer Knights, and which were enemies. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The Winter fairies had all risen at once – those few who had been permitted to keep their swords on them reaching for them instantly. They stared at the Summer Fairies with something between disbelief, shock, and betrayal.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Wort had outsmarted us again – if any Winter fairies did survive the massacre, they would believe that it was the Summer Court behind the whole thing. And even if his few Summer soldiers died in battle, the Winter fairies would keep fighting until all of my loyal men were killed, too. My heart broke with the realization, this was going to be a massacre.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I could see the Winter Queen's face – staring at me with quiet, steely disappointment – as she reached for her sword, ready to begin the fight anew. Shasta had unleashed her sword, and was already running through Summer Knights.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No!” I gasped, as her sword cut through Redrain, a Summer Knight I knew to be one of the most loyal in Logan's retinue. But it was too late. Once more, all Summer Knights were Shasta's enemy; the cease-fire would never be signed.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Shasta looked at me with pure hate in her eyes. I had not only betrayed her brother, but the entire Winter Kingdom. How could she have ever thought I was a friend? Rodney rushed over to her, trying to explain what had happened, trying to explain to Shasta and the Winter Queen. With a blow from the blunt of her own sword’s handle, Shasta knocked Rodney down.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rodney’s face was in disbelief. Shasta had tears in her eyes as she shouted. “Mother was right. Winter and Summer cannot be! We trusted you and Breena, but it looks like we fell into Summer’s treacherous hands...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rodney got up, wanting to approach Shasta, but she brandished her sword menacingly. “Shasta, my love, my darling...that is not true at all.” Shasta thrust her sword toward Rodney, and he jumped out of her way just in time. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No!” I shouted, unable to believe Shasta would actually try to harm Rodney. All around me, there was chaos and bloodshed. I had to gain control. I had to find out who were Wort’s men in disguise as Summer Knights, and who were my own loyal knights. Rodney was preoccupied with Shasta, trying to persuade her to our side, telling her, it was not my doing.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The Winter Queen stood back, a gleaming silver blue sword in her hand. She looked from Rodney to Shasta and then to me. She turned to me, taking long strides toward me, her hand firmly clutching her sword. For a second, she reminded me of Kian, the first time I saw him, determined, cold, and beautiful. I was fully the enemy.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Then the door opened, and in rushed Logan with some men I recognized. Men from the Wolf Fey...Logan’s clan. “Breena!” he shouted, fighting his way over to me. Anyone who was a loyal Summer Knight would not attack him so he knew who to fight off. He saw the look of the Winter Queen and how she was headed towards me with her sword. “Stop, Winter Queen!” he roared, his voice sounding loud and clear above the battle cries and shouting. “This is not Breena’s doing. We have Pixies glamouring as Summer Knights amongst us. Pixies, who is the enemy of Winter and Summer!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The Winter Queen stopped in her steps and looked around. Logan stood tall and broad-shouldered like the wolf warrior that he was. His face open and earnest, trustworthy. Although he and I were engaged, werewolves in Feyland held no allegiance to the Summer or Winter Court. The Werewolf Fey had their own sovereignty like the Pixies. They stood out from the elegant Winter and Summer fairies with their broader build, more animalistic nature, and general easy-going nature. The Werewolf Fey were peaceful creatures who went back and forth between lands, between kingdoms.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tell me, Wolf,” the Winter Queen said. “How are we to tell who is a glamoured Pixie and who isn’t, were I to believe you?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Simple,” Logan said, grabbing a Summer Knight near him. He took a whiff. “Pixies smell different.” He threw the Summer Knight to the ground and brought his boots down to the knight’s face, while holding the point of his sword to his neck. “Pixies smell like rotting flesh.” At that, he grounded his boots hard against the man’s face. “Change back to your ugly self before I change your face for you,” Logan said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The man gave Logan a sheer look of contempt before his face morphed into a face of uneven proportions – small squinty eyes, large crooked nose, thin lips with jagged teeth. It was the face of a Pixie. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I let out a breath of relief. Logan had his eyes on the Pixie, but he looked up quickly to meet my eyes. I nodded to let him know I understood what he was doing. With a gesture, the werewolves from his clan spread out going from Summer Knight to Summer Knight, their nose leading the way to a Pixie in disguise. As I watch Logan lead, my heart swelled with pride at how he confidently led the wolves around the room. There was fighting and resistance whenever a Pixie was discovered, but now that there was a way to identify them, the room became less chaotic. Order was being restored, and soon the Winter Queen and her party were looking around, no longer with anger in their eyes at me and my loyal Summer Knights. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Logan was making his way over to me. I was so relieved to see him at last that I did not realize I had opened my arms to him. He had a determined murderous look in his eyes, though, which I did not understand. Something was wrong.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Epilogue")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")])])]), _vm._v(" turned my head to see what Logan was staring at with such anger and wariness. Before I could see, I felt a pair of strong hands grab me, hands I knew all too well. Minutes before, Kian had been caressing me, stroking my hair, but now he was rough, violent, as he grabbed me by the hair and threw me to the ground, bruising me against the hard, sharp stone.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wait, Kian!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But my cry was cut short, as I tasted blood in my mouth. I looked down in shock as the pain began to throb and overtake me. There, buried deep within my chest, was the dagger Kian had shown me the first time we met, with its Winter-carvings on the handle, stained with red blood.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kian...” I spluttered, as he stood over me, his face still stone-still, devoid of any expression. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("So my dreams had come true, after all. I would be killed by the Winter Prince.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("That was the last thing I thought, as my thoughts spun in circles, and then into darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "font-size": "x-small",
      "font-weight": "bold",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("***********************************")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Thank you  for reading Silver Frost!  Be sure to check out Silver Frost to see what happens to Breena, Kian, Logan, Shasta, and Rodney!  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Enjoyed Silver Frost, be sure to let others know about it by sharing your review on the retailer you got the book from. Your support makes it possible for this book and other positive books featuring a strong female character with a positive message to be published!  Thank you for your support!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Golden Scroll Publishing – an API Story Initiative")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0